import React, { Component } from "react";
import {
  NormalInput,
  NormalTextarea,
  NormalButton,
  NormalSelect,
  NormalDate,
  NormalModal,
  NormalDateTime,
} from "component/common";

import { ChangePayment } from "component/Admin/TransactionHistory/ChangePayment";
import { SignPanel } from "component/common/SignPanel";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { getPayment, createPayment } from "redux/actions/payment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { history } from "helpers";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
} from "redux/actions/common";
import { dateFormat } from "service/helperFunctions";
import "./style.scss";
import SimpleReactValidator from "simple-react-validator";
import closeIcon from "assets/images/close.png";
import helpers from "../../../../service/Helper";
import { Toast } from "service/toast";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Paymentcheckout } from "./paymentgate";
//import { Elements } from "@stripe/react-stripe-js";
//import { loadStripe } from "@stripe/stripe-js";
import cardIcon from "assets/images/icons8-credit-card-64.png";
import { transactionSettingListAct } from "redux/actions/transactionHistory";
import jsPDF from "jspdf";
import printJS from "print-js";
import { CredentialConfirmation } from "../credentialConfirmation";

//const stripePromise = loadStripe("pk_test_GGEOsV78TJcV1OcvWcaH6lnz");

export class MakePaymentClass extends Component {
  state = {
    formFields: {
      name: "",
      contact: "",
      address: "",
      searchStaff: "",
      payTableDropDownValue: "",
    },
    responseData: {},

    premisesOption: [],
    selectedCards: [],
    selectedCardsPayAmount: 0,
    cardOption: [],
    ewalletoptions: [],

    ewalletField: {
      pay_typeid: null,
      pay_amt: "",
      credit_debit: true,
    },
    cardField: {
      pay_typeid: null,
      pay_amt: "",
      credit_debit: true,
      pay_rem1: "",
      pay_rem2: "",
      pay_rem3: "",
      pay_rem4: "",
      App_code: "",
    },
    balance: 0,
    errorMessage: "123",
    prepaidCustomerData: [],
    voucherCustomerData: [],
    creditNoteCustomerData: [],
    pointData: [],
    pointDataUserEnterAmount: 0, //Saleem
    accountHeader: [],
    isMakePaymentButtonClicked: "false",
    isTreatmentDoneButton: true,
    itemProductAmount: 0,
    itemServiceAmount: 0,
    itemProductServiceVoucherAmount: 0,
    displayTablePrepaid: [],
    displayTableCreditNote: [],
    displayTableVoucher: [],
    displayTablePoint: [],
    paytableData: [],
    paytableFullData: [],
    payGroupData: [],
    selectPaymentGroup: "",
    selectPaymentGroupId: "",
    isSelectedPaymentType: "",
    displayModelPaymentType: "",
    txtUserPayAmount: 0,
    isOpenSubPayment: false,
    pay_rem4: "",
    DateofPay: new Date(),
    MinimumDate: new Date(),
    is_paymentdate: false,
    isMakePaymentLoading: false,
    pointHeader: [],
    paymentgateway: false,
    paymentCompleted: false,
    cust_id: null,
    cust_stripeid: null,
    prepaidTax: 0,
    cnTax: 0,
    voucherTax: 0,
    oldbillTax: 0,
    paidselected: 0,
    billableamount: 0,
    taxamt: 0,
    roundingBalanceAmount: 0,

    cust_sign: "",
    signatureBtnDisable: true,
    signatureBtnHide: true,
    getPrepaidHeader: {},
    prepaidTotalUseAmt: "",
    preadidCartUseIds: [],
    BackupPreadidCartUseIds: [],
    selectedPaygroupId: "",
    memberVoucherNumber: "",
    prepaidInputValue: {},
    stagedValues: {},
    isLoginConfirmation: false,
  };

  componentDidMount() {
    this.handleSign({});
    this.getInvoiceSettingList();
    console.log(this.props.tokenDetails.backendAllowedMonths, "allowMonths");
    let From = new Date();
    let { MinimumDate, DateofPay } = this.state;
    let firstdayMonth = new Date(
      From.getFullYear(),
      From.getMonth() - Number(this.props.tokenDetails.backendAllowedMonths),
      From.getDate() + 1
    );

    if (
      this.props.CartPaymentDate &&
      this.props.CartPaymentDate["DateofPayment"]
    ) {
      DateofPay = new Date(this.props.CartPaymentDate.DateofPayment);
    } else {
      DateofPay = new Date();
    }
    MinimumDate = firstdayMonth;
    this.setState({
      MinimumDate,
      DateofPay,
    });
    this.getPayment();
    this.getPayGroup();
    this.getFullPayTable();
    this.getPrepaidData();
    this.getCreditNoteAccountData("");
    this.getVoucherData("");
    this.getPointData();
    console.log("cartdata From cart", this.props.cartData);
  }
  componentWillMount = () => {
    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
    });
  };

  // getInvoiceSettingList
  getInvoiceSettingList = () => {
    this.props.getCommonApi(`invoicetemplateconfig/`).then(async (res) => {
      let { data, status } = res;

      if (status == 200) {
        if (data && data.length > 0) {
          let filterOriginalList = data;
          console.log(filterOriginalList, "filterOriginallist");
          const modifiedList = filterOriginalList.reduce(
            (result, item) => {
              result[item.type].push(item);
              return result;
            },
            { headerList: [], footerList: [], bodyList: [] }
          );
          let filterList = [];
          filterList.push(modifiedList);
          console.log(modifiedList, "modifiedList");
          this.props.transactionSettingListAct(filterList);
        }
      }
    });
  };

  handleSign = (data) => {
    console.log("cartId", this.props.cartId);
    this.props
      .getCommonApi(`tempcustsigninvoice/?cart_id=${this.props.cartId}`)
      .then(async (key) => {
        let { data } = key;
        let { cust_sig } = this.state;
        if (data) {
          console.log(data?.cust_sig, "sign");

          await this.setState({
            cust_sign: data?.cust_sig,
          });
        }
      });
  };

  // handleClearSignPad
  handleClearSign = () => {
    this.setState({ signatureBtnDisable: true });
  };

  // get method for payment detail against appointment
  getPayment = () => {
    let { id, cartId, cartData } = this.props;
    let { cust_id, cust_stripeid } = this.state;
    //id = 82318;
    //cartId = "ICMD100226";
    //cartData={"status":200,"message":"Listed Succesfully","error":false,"data":[{"id":57500,"cust_noid":82318,"customer":"test17011","customercode":"021427HQ","cart_id":"ICHQ100234","cart_date":"2021-03-14","cart_status":"Inprogress","lineno":1,"check":"New","itemcodeid":10067,"itemdesc":"Short - Chin Length(Before Shoulder) 128","quantity":1,"price":"128.00","total_price":"128.00","sitecodeid":31,"sitecode_name":"HQ OFFICE (DEMO)","sitecode":"HQ","discount":"0.00","discount_amt":0,"discount_price":"128.00","additional_discount":0,"additional_discountamt":0,"deposit":"128.00","trans_amt":"128.00","tax":0,"itemstatus":null,"ratio":"100.000000000000000","helper_name":null,"done_sessions":null,"type":"Deposit","treatment_account":null,"treatment":null,"deposit_account":null,"prepaid_account":null,"item_uom":null,"recorddetail":"Service","itemtype":"SINGLE","item_class":"HERBAL TREATMENT","sales_staff":"SEQ ADMIN","service_staff":"","total_disc":"0.00","treatment_name":"Short - Chin Length(Before Shoulder) 128  (1)","item_name":"Short - Chin Length(Before Shoulder) 128"}],"subtotal":"128.00","discount":"0.00","trans_amt":"128.00","deposit_amt":"128.00","billable_amount":"128.00"}
    if (id) {
      this.props
        .getPayment(
          `?cart_date=${dateFormat(
            new Date(),
            "yyyy-mm-dd"
          )}&cust_noid=${id}&cart_id=${cartId}`
        )
        .then((res) => {
          console.log("Payment Details:", res);
          console.log(res.data.cust_noid);
          cust_id = res.data.cust_noid;
          cust_stripeid = res.data.cust_stripeid;
          this.setState({ cust_id, cust_stripeid });
          let { data, status, prepaid_data } = res;
          if (status === 200) {
            this.setState({
              responseData: data,
              balance: Number(data.billable_amount),
              txtUserPayAmount: Number(data.billable_amount),
              billableamount: Number(data.billable_amount),
              taxamt: Number(data.tax_amt),
              prepaid_data: prepaid_data.prepaid,
              product_only: prepaid_data.product_only,
              service_only: prepaid_data.service_only,
              all_only: prepaid_data.all_only,
              is_paymentdate: data.is_paymentdate,
            });
          }
        });
    }

    //let {cartData} = this.props;
    let stringifiedCartData = cartData.data;

    let {
      itemProductAmount,
      itemServiceAmount,
      itemProductServiceVoucherAmount,
    } = this.state;
    if (stringifiedCartData) {
      stringifiedCartData.map((item) => {
        //alert(JSON.stringify(item));
        if (item.recorddetail === "Product") {
          itemProductAmount += parseFloat(item.total_price);
        }
        //if (item.recorddetail === "Service") {
        //Yoonus
        if (item.recorddetail === "Service" || item.recorddetail === "TP Service") {
          itemServiceAmount += parseFloat(item.total_price);
          console.log(itemServiceAmount);
          console.log(item.total_price);
        }
        if (
          item.recorddetail === "Product" ||
          item.recorddetail === "Service" ||
          item.recorddetail === "Voucher" ||
          item.recorddetail === "TP Service" ||
          item.recorddetail === "TP Product" ||
          item.recorddetail === "TP Voucher"
        ) {
          itemProductServiceVoucherAmount += parseFloat(item.total_price);
        }
      });
    }
    this.setState({
      itemProductAmount,
      itemServiceAmount,
      itemProductServiceVoucherAmount,
    });
  };
  // set data to dropdown fields
  getDataFromResponses = (data) => {
    let { cardOption, premisesOption } = this.state;
    for (let key of data.CARD) {
      cardOption.push({ label: key.pay_description, value: key.id });
    }
    for (let key of data.CASH) {
      premisesOption.push({ label: key.pay_description, value: key.id });
    }
    this.setState({
      cardOption,
      premisesOption,
    });
  };

  connectSerial = async () => {
    let isPortOpened =
      localStorage.getItem("isPortOpened") === "true" ? true : false;
    try {
      if (!isPortOpened) {
        const ports = await navigator.serial.getPorts();
        if (ports.length === 0) {
          console.error("No available serial ports.");
          return;
        }
        const port = ports[0];
        await port.open({ baudRate: 9600 });
        isPortOpened = true;
        localStorage.setItem("isPortOpened", "true"); // Store the updated state in localStorage
      }

      const port = await navigator.serial.requestPort();

      if (!port.readable || !port.writable) {
        const writer = port.writable.getWriter();
        const data = new Uint8Array([77]); // W<CR>
        await writer.write(data);
        this.readLoop(port);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  readLoop = async (port) => {
    try {
      // eslint-disable-next-line no-undef
      const textDecoder = new TextDecoderStream();
      const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
      const reader = textDecoder.readable.getReader();

      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          reader.releaseLock();
          break;
        }
        console.log(value);
      }
    } catch (error) {
      console.error("Read loop error:", error.message);
    }
  };

  runConnect = async () => {
    try {
      await this.connectSerial();
      console.log("Connect function executed successfully.");
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  //   handleSerialPortRequest = async () => {
  //     //without using textencoderstream

  // try {
  //   const port = await navigator.serial.requestPort();
  //  debugger;
  //  // Wait for the serial port to open.
  //  //await port.open({ baudRate: 9600 });
  //  // Listen to data coming from the serial device.
  //  const writer = port.writable.getWriter();

  //  const data = new Uint8Array([77]); // hello
  //  await writer.write(data);

  //  // Allow the serial port to be closed later.
  //  writer.releaseLock();

  //  } catch (error) {
  //      console.log("error on catch");
  //    }
  //     // try {
  //     //   const port = await navigator.serial.requestPort();
  //     //   const { usbProductId, usbVendorId } = port.getInfo();
  //     //   console.log(usbProductId);
  //     //   console.log(usbVendorId);
  //     //   if (!usbProductId && !usbVendorId) {
  //     //     await port.open({ baudRate: 9600 });
  //     //   }

  //     //   if (port) {
  //     //     const textEncoder = new TextEncoder();
  //     //     const data = textEncoder.encode("ping");
  //     //     const writer = port.writable.getWriter();
  //     //     writer.write(data);
  //     //     writer.releaseLock();
  //     //   }
  //     //   // Additional logic or handling can be added here as needed
  //     // } catch (error) {
  //     //   console.error("Error occurred:", error);
  //     // }
  //   };

  handleMultiple = ({ target: { value, name } }) => {
    console.log("handleMultiple", value, name);
    let formFields = Object.assign({}, this.state.formFields);

    formFields[name] = value;

    this.setState({
      formFields,
    });
  };
  getVoucherData = (api) => {
    this.props
      .getCommonApi(`voucher/?cust_id=${this.props.id}${api}`)
      .then((key) => {
        let { data } = key;
        let { voucherCustomerData } = this.state;
        voucherCustomerData = data;
        console.log("voucherCustomerData", data);
        // accountHeader = header_data;
        this.setState({ voucherCustomerData }, () => {
          console.log("test");
          this.HideVoucherTableData();
        });
      });
  };

  getPrepaidData = () => {
    this.getPrepaidAccountData("");
  };
  getPrepaidAccountData = () => {
    // this.props
    //   .getCommonApi(`prepaidacclist/?cust_id=${this.props.id}${api}`)
    this.props
      .getCommonApi(
        `prepaidaccpaymentlist/?cust_id=${this.props.id}&cart_id=${this.props.cartId}`
      )
      .then((key) => {
        let { data, header_data } = key;

        if (header_data) {
          let { total_useamt, total_cartuse_ids } = header_data;

          this.setState({
            prepaidTotalUseAmt: total_useamt,
            preadidCartUseIds: total_cartuse_ids,
          });
        }
        // if (deletedBtn) {
        //   console.log(deletedBtn, deleteArrayList);
        //   let mergeCartUserIds = [
        //     ...this.state.BackupPreadidCartUseIds,
        //     ...deleteArrayList,
        //   ];
        //   this.setState({ preadidCartUseIds: mergeCartUserIds });
        // }

        let { prepaidCustomerData } = this.state;
        //prepaidCustomerData = data;
        prepaidCustomerData = [];
        console.log("prepaidCustomerData", "dataprepaidCustomerData");
        for (let item of data) {
          let itemData = {};
          itemData["conditiontype1"] = item.conditiontype1;
          itemData["cust_code"] = item.cust_code;
          itemData["all"] = item.all;
          itemData["exp_status"] = item.exp_status;
          itemData["exp_date"] = item.exp_date;
          itemData["last_update"] = item.last_update;
          itemData["line_no"] = item.line_no;
          itemData["id"] = item.id;
          itemData["pp_amt"] = item.pp_amt;
          itemData["pp_bonus"] = item.pp_bonus;
          itemData["outstanding"] = item.outstanding;
          itemData["pp_no"] = item.pp_no;
          itemData["pp_total"] = item.pp_total;
          itemData["prepaid"] = item.prepaid;
          itemData["product"] = item.product;
          itemData["remain"] = item.remain;
          itemData["sa_date"] = item.sa_date;
          itemData["service"] = item.service;
          itemData["topup_amt"] = item.topup_amt;
          itemData["type"] = item.type;
          itemData["use_amt"] = item.use_amt;
          itemData["pp_desc"] = item.pp_desc;
          itemData["redeem_amount"] = item?.redeem_amount;
          itemData["is_allowprepaid"] = item?.is_allowprepaid;
          itemData["cartuse_ids"] = item?.cartuse_ids;

          if (item.conditiontype1 === "Service Only") {
            if (Number(this.state.service_only) > Number(item.remain)) {
              itemData["Finaluse_amt"] = item.remain;
            } else {
              itemData["Finaluse_amt"] = this.state.service_only;
            }
          }
          if (item.conditiontype1 === "Product Only") {
            if (Number(this.state.product_only) > Number(item.remain)) {
              itemData["Finaluse_amt"] = item.remain;
            } else {
              itemData["Finaluse_amt"] = this.state.product_only;
            }
          }
          if (item.conditiontype1 === "All") {
            let finalamount = Number(this.state.all_only);
            if (this.state.prepaid_data) {
              this.state.prepaid_data
                .filter((dataitem) => dataitem.prepaid_id == item.id)
                .map((filteritem) => {
                  finalamount =
                    Number(this.state.all_only) - Number(filteritem.deposit);
                });
            }

            if (Number(finalamount) > Number(item.remain)) {
              itemData["Finaluse_amt"] = Number(item.remain).toFixed(2);
            } else {
              itemData["Finaluse_amt"] = Number(finalamount).toFixed(2);
            }
          }

          prepaidCustomerData.push(itemData);

          console.log(
            "prepaidCustomerData***",
            JSON.stringify(prepaidCustomerData)
          );
        }
        this.setState({ prepaidCustomerData }, () => {
          //this.HidePrepaidTableData();
        });
      });

    // accountHeader = header_data;
  };
  getCreditNoteAccountData = (api) => {
    this.props
      .getCommonApi(`creditnotelist/?cust_id=${this.props.id}${api}`)
      .then((key) => {
        let { data } = key;

        console.log("creditNoteList", JSON.stringify(data));

        let { creditNoteCustomerData } = this.state;
        creditNoteCustomerData = data;
        this.setState({ creditNoteCustomerData }, () => {
          this.HideCreditNoteTableData();
        });
      });
  };

  getPointData = () => {
    let { txtUserPayAmount, pointHeader } = this.state;
    //let { id, cartId, cartData } = this.props;
    this.props
      .getCommonApi(
        `customerpoints/?cust_noid=${this.props.id}&enter_pointamt=${txtUserPayAmount}&cart_id=${this.props.cartId}`
      )
      .then((key) => {
        console.log(key, "pointdataget");
        let { data, header_data } = key;
        let { pointData } = this.state;
        pointData = data;
        pointHeader = header_data;
        pointHeader.RedeemableCurrency = parseFloat(
          pointHeader.redeem_currency
        );
        // pointHeader.RedeemableCurrency =
        //   parseFloat(pointHeader.cust_point_value) *
        //   parseFloat(pointHeader.redeem_currency);
        console.log(pointHeader.RedeemableCurrency, "RedeemableCurrency");
        this.setState({ pointData, pointHeader }, () => {
          this.HidePointTableData();
        });
      });
  };

  HidePointTableData = () => {
    let { pointData, displayTablePoint } = this.state;
    displayTablePoint.map((item) => {
      var selectedPoint = pointData.filter((point) => point.id != item);
      this.setState({ pointData: selectedPoint });
    });
  };
  getPayGroup = () => {
    this.props.getCommonApi(`paygroup/`).then((res) => {
      console.log(res, "payGroupRes");
      let { payGroupData } = this.state;
      for (let key of res.data) {
        payGroupData.push({
          label: key.pay_group_code,
          value: key.id,
          picturelocation: key.picturelocation,
          isLogin: key.requireauth,
        });
      }
      this.setState({
        payGroupData,
      });
    });
  };
  getFullPayTable = () => {
    this.props.getCommonApi(`paytablenew/`).then((res) => {
      console.log(res, "paytablefulldata");
      let { paytableFullData } = this.state;
      paytableFullData = res.data;
      this.setState({
        paytableFullData,
      });
    });
  };

  getPayTableIdBasedOnPaygroupId = () => {
    let { paytableFullData, selectedPaygroupId } = this.state;
    console.log(selectedPaygroupId);
    console.log(paytableFullData);
    if (paytableFullData) {
      const test = paytableFullData.filter(
        (res) => res.pay_groupid === selectedPaygroupId || ""
      );
      return test[0]?.id ?? "";
    } else {
      return "";
    }
  };

  getPayTableNameBasedOnId = (payTableId) => {
    // gt_group: "GT1"
    // id: 6
    // pay_code: "UOBPN"
    // pay_description: "UOB PAYNOW"
    // pay_group_name: "UOB"
    // pay_groupid: 22
    let { paytableFullData } = this.state;
    // if (
    //   isSelectedPaymentType == "VOUCHER" ||
    //   isSelectedPaymentType == "PREPAID" ||
    //   isSelectedPaymentType == "Credit" ||
    //   isSelectedPaymentType == "OLD BILL"
    // ) {
    //   const test = paytableFullData.filter(
    //     res => res.pay_group_name.trim() == isSelectedPaymentType.trim()
    //   );
    //   return test[0].pay_description;
    // } else {
    console.log(payTableId);
    console.log(paytableFullData);

    const test = paytableFullData.filter((res) => res.id == payTableId);
    console.log(test);
    return test[0]?.pay_description ?? "";
    // }
  };

  handleChangeTextBox(event) {
    this.setState({
      txtUserPayAmount: event.target.value,
    });
  }
  handleChangeRemarkBox(event) {
    this.setState({
      pay_rem4: event.target.value,
    });
  }
  handleChange = (value, name) => {
    let formFields = Object.assign({}, this.state.formFields);

    formFields[name] = value;
    this.setState({
      formFields,
    });
    let {
      balance,
      selectedCards,
      txtUserPayAmount,
      isOpenSubPayment,
      paidselected,
      prepaidTax,
      cnTax,
      voucherTax,
    } = this.state;
    isOpenSubPayment = false;

    //var gstforthispayment = parseFloat(parseFloat(txtUserPayAmount)*(this.state.responseData.gst_percent/100)).toFixed(2);
    //console.log("balance", balance);
    //console.log("txtUserPayAmount", txtUserPayAmount);

    //if (parseFloat(balance) > parseFloat(txtUserPayAmount) ) {
    //} else {
    //  txtUserPayAmount = parseFloat(txtUserPayAmount) - ( parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax)  )
    //}

    var gstforthispayment = parseFloat(
      (parseFloat(txtUserPayAmount) /
        parseFloat(100 + this.state.responseData.gst_percent)) *
        parseFloat(this.state.responseData.gst_percent)
    ).toFixed(2);

    selectedCards.push({
      pay_typeid: value,
      pay_amt: parseFloat(txtUserPayAmount),
      pay_gst: parseFloat(gstforthispayment),
      credit_debit: false,
      pay_premise: true,
      prepaid: false,
      pay_rem4: this.state.pay_rem4,
    });
    console.log("handlechange");
    //balance = parseFloat(balance - txtUserPayAmount).toFixed(2);
    //paidselected = parseFloat(paidselected + txtUserPayAmount).toFixed(2);
    paidselected = parseFloat(
      parseFloat(paidselected) + parseFloat(txtUserPayAmount)
    ).toFixed(2);
    balance = parseFloat(
      parseFloat(balance) - parseFloat(txtUserPayAmount)
    ).toFixed(2);

    //var totolGT2Tax =  parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax);
    //balance = parseFloat(balance - totolGT2Tax).toFixed(2);

    txtUserPayAmount = balance;
    console.log(txtUserPayAmount, "txtUserPayAmount");

    this.setState({
      txtUserPayAmount,
      balance,
      isOpenSubPayment,
      paidselected,
    });
  };
  handleCreditChange = (value, name) => {
    let cardField = Object.assign({}, this.state.cardField);

    cardField[name] = value;
    this.setState({
      cardField,
    });
  };
  handleTreatmentDone = () => {
    let { selectedCards, DateofPay, paytableFullData, payGroupData } =
      this.state;

    let PayTypeId = payGroupData.filter(
      (item) => String(item?.label).toUpperCase() === "CASH"
    );
    let test = [];
    if (paytableFullData && PayTypeId) {
      test = paytableFullData.filter(
        (res) => res.pay_groupid === PayTypeId[0].value || ""
      );
    }

    if (selectedCards.length == 0) {
      selectedCards.push({
        pay_typeid: test[0]?.id,
        //pay_typeid: 21, //Pureskin
        //pay_typeid: 2, //staging
        //pay_typeid: 31, //twoherbs
        pay_amt: 0,
        pay_gst: 0,
        credit_debit: false,
        pay_premise: true,
        prepaid: false,
        pay_rem4: this.state.pay_rem4,
        pay_gst: 0,
      });
    }
    let data = selectedCards;

    let { id, cartId } = this.props;
    this.props
      .createPayment(
        `?cart_date=${dateFormat(
          new Date(),
          "yyyy-mm-dd"
        )}&cust_noid=${id}&cart_id=${cartId}&pay_date=${dateFormat(
          new Date(DateofPay),
          "yyyy-mm-dd"
        )}`,
        data
      )
      .then((res) => {
        history.push(`/admin/billing/print/bill/${res.data.sa_transacno}`);
      });
  };
  // create payment detail
  handleSubmit = () => {
    let { selectedCards, DateofPay } = this.state;
    /*
      .createPayment(
        `?cart_date=${dateFormat(
          new Date(),
          "yyyy-mm-dd"
        )}&cust_noid=${id}&cart_id=${cartId}&pay_date=${dateFormat(
          new Date(DateofPay),
          "yyyy-mm-dd"
        )}`,
        data
      )
    */
    let data = selectedCards;
    let { id, cartId } = this.props;
    this.props
      .createPayment(
        `?cart_date=${dateFormat(
          new Date(),
          "yyyy-mm-dd"
        )}&cust_noid=${id}&cart_id=${cartId}&pay_date=${dateFormat(
          new Date(DateofPay),
          "yyyy-mm-dd"
        )}&transremark=${this.state.pay_rem4}`,
        data
      )
      .then((res) => {
        this.runConnect();
        this.setState({
          isMakePaymentLoading: false,
        });
        history.push(`/admin/billing/print/bill/${res.data.sa_transacno}`);
      });
    this.setState({
      isMakePaymentLoading: false,
    });
  };
  // handle print priview
  handlePrintPreview = () => {
    let { selectedCards, cust_id } = this.state;
    let payload = selectedCards;
    let { cartId } = this.props;
    this.props
      .commonCreateApi(
        `customerreceiptprintbeforecheckout/?cart_id=${cartId}&cust_id=${cust_id}
      `,
        payload
      )
      .then((res) => {
        let { status, data } = res;
        if (status === 200 && data?.pdf_link != "") {
          console.log(data?.pdf_link);
          printJS(data?.pdf_link);
          //window.open(data?.pdf_link);
        }
      });
  };
  checkPayTypeIdAlreadyExists(val) {
    return this.state.selectedCards.some((item) => val === item.pay_typeid);
  }

  addCreditCard = (async) => {
    if (!this.validator.fieldValid("cardFieldType")) {
      this.validator.showMessageFor("cardFieldType");
      return;
    }

    let { cardField, selectedCards, balance, txtUserPayAmount, paidselected } =
      this.state;
    let userPayAmount = parseFloat(txtUserPayAmount);
    if (parseFloat(this.state.responseData.billable_amount) > 0) {
      if (userPayAmount == 0) {
        return;
      }
    }
    if (this.checkPayTypeIdAlreadyExists(cardField.pay_typeid)) {
      let result =
        this.getPayTableNameBasedOnId(cardField.pay_typeid) + " already exists";
      Toast({
        type: "error",
        message: result,
      });
      return;
    } else {
      console.warn("addcreditcard");

      //var gstforthispayment = parseFloat(parseFloat(userPayAmount)*(this.state.responseData.gst_percent/100)).toFixed(2);

      //if (parseFloat(balance) > parseFloat(userPayAmount) ) {
      //} else {
      //  userPayAmount = parseFloat(userPayAmount) - ( parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax)  )
      // }

      var gstforthispayment = parseFloat(
        (parseFloat(userPayAmount) /
          parseFloat(100 + this.state.responseData.gst_percent)) *
          parseFloat(this.state.responseData.gst_percent)
      ).toFixed(2);

      selectedCards.push({
        pay_typeid: cardField.pay_typeid,
        pay_amt: parseFloat(userPayAmount),
        pay_gst: parseFloat(gstforthispayment),
        credit_debit: true,
        pay_premise: false,
        pay_rem1: cardField.pay_rem1,
        pay_rem2: cardField.pay_rem2,
        pay_rem3: cardField.pay_rem3,
        pay_rem4: this.state.pay_rem4,
        prepaid: false,
      });
    }

    paidselected = parseFloat(
      parseFloat(paidselected) + parseFloat(userPayAmount)
    ).toFixed(2);
    balance = parseFloat(
      parseFloat(balance) - parseFloat(userPayAmount)
    ).toFixed(2);

    //balance = parseFloat(balance - userPayAmount).toFixed(2);
    ////var totolGT2Tax =  parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax);
    ////balance = parseFloat(balance - totolGT2Tax).toFixed(2);
    //paidselected = parseFloat(paidselected + userPayAmount).toFixed(2);

    //Yoonus check balance against gst
    //if (this.state.responseData.is_exclusive && this.state.responseData.gst_percent > 0){
    //  var gstforthispayment = parseFloat(userPayAmount*(this.state.responseData.gst_percent/100)).toFixed(2);
    //  balance = parseFloat(balance - gstforthispayment).toFixed(2);
    //  console.log(gstforthispayment);
    //}

    this.setBalanceToAllTextBoxes(balance);

    this.setState({ isOpenSubPayment: false, paidselected: paidselected });

    //Yoonus this was previous
    //this.setState({ isOpenSubPayment: false });
    //this.setBalanceToAllTextBoxes(balance);
  };

  validateMemberVoucher = () => {
    let { memberVoucherNumber, txtUserPayAmount, isSelectedPaymentType } =
      this.state;
    let { tokenDetails } = this.props;
    let isMemberValidate = tokenDetails.validatemembervoucher;
    if (isMemberValidate) {
      let data = {
        voucher_no: memberVoucherNumber,
        enter_amount: Number(txtUserPayAmount),
      };
      this.props.commonCreateApi("validatemembervoucher/", data).then((res) => {
        console.log(res, "memberRes");
        let allowMemberVoucher = res.allow;
        if (allowMemberVoucher) {
          this.addMemberVoucher(res.voucheramount);
        } else {
          Toast({
            type: "error",
            message: "Member Voucher is not allowed",
          });
          this.setState({ isOpenSubPayment: false });
        }
      });
    } else {
      this.addMemberVoucher(txtUserPayAmount);
    }
  };

  addMemberVoucher = (voucheramount) => {

    let {
      memberVoucherNumber,
      selectedCards,
      balance,
      txtUserPayAmount,
      paidselected,
      paytableData,
      roundingBalanceAmount,
      billableamount,
    } = this.state;

    if (!this.validator.fieldValid("memberVoucherNumber")) {
      this.validator.showMessageFor("Member Voucher Number");
      return;
    }

    //let userPayAmount = parseFloat(txtUserPayAmount);
    //Yoonus
    let userPayAmount = parseFloat(voucheramount);
    txtUserPayAmount = parseFloat(userPayAmount).toFixed(2);
    if (parseFloat(this.state.responseData.billable_amount) > 0) {
      if (userPayAmount == 0) {
        return;
      }
    }
    let payTypeId = paytableData[0].value;
    var rounding = 0;
    //Rounding flow
    if (paytableData[0].rounding) {
      //txtUserPayAmount = parseFloat(txtUserPayAmount).toFixed(2);
      //Yoonus
      txtUserPayAmount = parseFloat(userPayAmount).toFixed(2);
      //console.log("voucherAmount", txtUserPayAmount)
      var n = (txtUserPayAmount + "").split(".")[1].split("")[1];
      var roundingBalance = 0;
      console.log(n);
      if (parseFloat(n) < 5 && parseFloat(n) != 0) {
        roundingBalance = "0.0" + "" + (5 - parseFloat(n));
      } else if (parseFloat(n) > 5) {
        roundingBalance = "0.0" + "" + (10 - parseFloat(n));
      }
      console.log(roundingBalance);
      roundingBalance = parseFloat(roundingBalance).toFixed(2);
      txtUserPayAmount = parseFloat(
        parseFloat(txtUserPayAmount) + parseFloat(roundingBalance)
      ).toFixed(2);
      console.log(roundingBalance);
      console.log(txtUserPayAmount);
      roundingBalanceAmount = parseFloat(roundingBalance).toFixed(2);
      console.log("roundingBalanceAmount", roundingBalanceAmount);
      rounding = 1;
    }
    //console.warn("add member voucher card");

    var gstforthispayment = parseFloat(
      (parseFloat(txtUserPayAmount) /
        parseFloat(100 + this.state.responseData.gst_percent)) *
        parseFloat(this.state.responseData.gst_percent)
    ).toFixed(2);

    //console.log("voucherAmount", txtUserPayAmount)
    selectedCards.push({
      pay_typeid: payTypeId,
      pay_amt: parseFloat(txtUserPayAmount),
      pay_gst: parseFloat(gstforthispayment),
      credit_debit: false,
      pay_premise: true,
      prepaid: false,
      pay_rem1: this.state.memberVoucherNumber,
      pay_rem4: this.state.pay_rem4,
      pay_is_rounding: rounding,
    });

    paidselected = parseFloat(
      parseFloat(paidselected) + parseFloat(txtUserPayAmount)
    ).toFixed(2);
    balance = parseFloat(
      parseFloat(balance) - parseFloat(txtUserPayAmount)
    ).toFixed(2);

    txtUserPayAmount = balance;
    if (parseFloat(txtUserPayAmount) < 0) {
      txtUserPayAmount = 0;
    }

    console.log("paidselected add", paidselected);
    this.setState({
      txtUserPayAmount,
      balance,
      paidselected,
      billableamount,
      roundingBalanceAmount,
      isOpenSubPayment: false,
    });
  };

  /*
  addPoint = selectedPoint => {
    let {
      balance,
      txtUserPayAmount,
      isOpenSubPayment,
      selectedCards,
      pay_rem4,
    } = this.state;
    
    if (txtUserPayAmount == 0) {
      Toast({
        type: "error",
        message: "Point is not allowed",
      });
      return;
    }
    const selectedPointAmount = parseFloat(selectedPoint.useamt);
    let pay_amt_setup = 0;
    if (selectedPointAmount <= parseFloat(txtUserPayAmount)) {
      pay_amt_setup = selectedPointAmount;
    } else {
      pay_amt_setup = txtUserPayAmount;
    }
    // if (selectedPointAmount <= parseFloat(txtUserPayAmount)) {
    //   pay_amt_setup = selectedPointAmount;
    // } else {
    //   Toast({
    //     type: "error",
    //     message: "Partial Amount is not applicable in Point",
    //   });
    //   return;
    // }
    //const payTypeId = 25;
    //const payTypeId = 23; //normal twoherbs
    //const payTypeId = 19; //healspa sensuous beauty21 appleskin jybeauty
    //const payTypeId = 7; //skinsoul
    //const payTypeId = 8; //glamour koiskin quantum
    //const payTypeId = 9; //beskin citibella tnc ingenious
    //const payTypeId = 31; //cuttour
    //const payTypeId = 35; //marma
    //const payTypeId = 12; //Embrace
    //const payTypeId = 99; //no point for pixie citibella avante bestbeauty demo destress sumi ch
    console.log(selectedPoint.cur_value);
    selectedCards.push({
      pay_typeid: payTypeId,
      pay_amt: parseFloat(pay_amt_setup),
      pay_premise: false,
      prepaid: false,
      credit_debit: false,
      points: true,
      cur_value: selectedPoint.cur_value,
      pay_rem4: pay_rem4,
      pay_rem2: selectedPoint.id,
      pay_gst: 0,

    });

    console.log("BeforeAdd-displayTableVoucher", this.state.displayTablePoint);
    let setdisplayTablePoint = this.state.displayTablePoint;
    setdisplayTablePoint.push(selectedPoint.id);
    this.setState({ displayTablePoint: setdisplayTablePoint });
    console.log("AfterAdd-displayTablePoint", this.state.displayTablePoint);
    this.HidePointTableData();

    balance = parseFloat(balance - pay_amt_setup).toFixed(2);

    //Yoonus check balance against gst
    //if (this.state.responseData.is_exclusive && this.state.responseData.gst_percent > 0){
    //  var gstforthispayment = parseFloat(pay_amt_setup*(this.state.responseData.gst_percent/100)).toFixed(2);
    //  balance = parseFloat(balance - gstforthispayment).toFixed(2);
    //  console.log(gstforthispayment);
    // }

    this.setBalanceToAllTextBoxes(balance);
    console.log(balance);
    this.setState({ isOpenSubPayment: false });

    //Yoonus previously was this
    //this.setState({ isOpenSubPayment: false });
    //this.setBalanceToAllTextBoxes(balance);

  };
  */

  addPrepaid = async (selectedPrepaid) => {
    //debugger;
    console.log("selectedPrepaid", JSON.stringify(selectedPrepaid));
    const prepaidExpDate = moment(selectedPrepaid.exp_date).format("YYYY-MM-DD");
    const todaysDate = moment(new Date()).format("YYYY-MM-DD");
    const isValid = moment(todaysDate).isSameOrAfter(prepaidExpDate);
    let userPayAmount = 0;
    let {
      itemServiceAmount,
      itemProductAmount,
      itemProductServiceVoucherAmount,
      txtUserPayAmount,
    } = this.state;

    userPayAmount = parseFloat(txtUserPayAmount);

    if (isValid) {
      Toast({
        type: "error",
        message: "Check Expiry Date",
      });
      return;
    }
    console.log("userPayAmount", JSON.stringify(userPayAmount));

    if (userPayAmount <= 0 || !selectedPrepaid?.is_allowprepaid) {
      Toast({
        type: "error",
        message: "Prepaid is Not allowed",
      });
      return;
    }

    // restrict prepaid value based on item
    // let totalCartUserIds = this.state.preadidCartUseIds;
    // let userSelectCartUseIds = selectedPrepaid.cartuse_ids;
    // let UserAllowstatus = false;
    // let TotalCartFilterIds = totalCartUserIds.filter((val) => {
    //   if (userSelectCartUseIds.includes(val)) {
    //     UserAllowstatus = true;
    //   }
    //   return !userSelectCartUseIds.includes(val);
    // });
    // if (UserAllowstatus) {
    //   this.setState({
    //     preadidCartUseIds: TotalCartFilterIds,
    //     BackupPreadidCartUseIds: TotalCartFilterIds,
    //   });
    // } else {
    //   Toast({
    //     type: "error",
    //     message: "Prepaid is Not allowed",
    //   });
    //   return;
    // }

    let selectedRemainingPrepaidAmount = parseFloat(
      selectedPrepaid.redeem_amount
    );
    //oldCode //let selectedRemainingPrepaidAmount = parseFloat(selectedPrepaid.remain);
    if (selectedRemainingPrepaidAmount < userPayAmount) {
      //return
    } else if (selectedRemainingPrepaidAmount > userPayAmount) {
      selectedRemainingPrepaidAmount = parseFloat(userPayAmount);
    }
    /*
    if (!this.validator.fieldValid("PrepaidBalanceAmount")) {
      this.validator.showMessageFor("PrepaidBalanceAmount");
      return;
    }
    if (!this.validator.fieldValid("PrepaidBalanceAmount")) {
      this.validator.showMessageFor("PrepaidBalanceAmount");
      return;
    }
*/

    if (selectedPrepaid.conditiontype1 === "Service Only") {
      //For Service
      if (parseFloat(itemServiceAmount) === 0) {
        Toast({
          type: "error",
          message: "Prepaid is Not allowed",
        });
        return;
      }
      if (parseFloat(itemServiceAmount) <= selectedRemainingPrepaidAmount) {
        userPayAmount =
          parseFloat(txtUserPayAmount) < parseFloat(itemServiceAmount)
            ? parseFloat(txtUserPayAmount)
            : parseFloat(itemServiceAmount);
        console.log(itemServiceAmount);
        console.log(userPayAmount);
      } else {
        userPayAmount = selectedRemainingPrepaidAmount;
        console.log(userPayAmount);
      }
      itemServiceAmount = itemServiceAmount - userPayAmount;
      this.setState({ itemServiceAmount });
    } else if (selectedPrepaid.conditiontype1 === "Product Only") {
      //For Product
      if (parseFloat(itemProductAmount) === 0) {
        Toast({
          type: "error",
          message: "Prepaid is not allowed",
        });
        return;
      }
      if (parseFloat(itemProductAmount) <= selectedRemainingPrepaidAmount) {
        userPayAmount =
          parseFloat(txtUserPayAmount) < parseFloat(itemProductAmount)
            ? parseFloat(txtUserPayAmount)
            : parseFloat(itemProductAmount);
        console.log(userPayAmount);
      } else {
        userPayAmount = selectedRemainingPrepaidAmount;
        console.log(userPayAmount);
      }
      itemProductAmount = itemProductAmount - userPayAmount;
      this.setState({ itemProductAmount });
    } else {
      if (parseFloat(itemProductServiceVoucherAmount) === 0) {
        Toast({
          type: "error",
          message: "Prepaid is not allowed",
        });
        return;
      }
      if (
        parseFloat(itemProductServiceVoucherAmount) <=
        selectedRemainingPrepaidAmount
      ) {
        userPayAmount =
          parseFloat(txtUserPayAmount) <
          parseFloat(itemProductServiceVoucherAmount)
            ? parseFloat(txtUserPayAmount)
            : parseFloat(itemProductServiceVoucherAmount);
        console.log(userPayAmount);
      } else {
        userPayAmount = selectedRemainingPrepaidAmount;
        console.log(userPayAmount);
      }
      itemProductServiceVoucherAmount =
        itemProductServiceVoucherAmount - userPayAmount;
      this.setState({ itemProductServiceVoucherAmount });
    }
    if (userPayAmount == 0) {
      Toast({
        type: "error",
        message: "Prepaid is not allowed",
      });
      return;
    }

    //const payTypeId = 23; //normal twoherbs healspahq
    const payTypeId = this.getPayTableIdBasedOnPaygroupId(); //sensuous beauty21 appleskin jybeauty
    //const payTypeId = 7;  //skinsoul
    //const payTypeId = 8;  //glamour koiskin quantum magicion pixie demo skinhugs mydemo ch
    //const payTypeId = 12;   //destress avante bestbeauty cuttour synthesis sumi navis
    //const payTypeId = 13;   //impression
    //const payTypeId = 11; //embrace
    //const payTypeId = 9;  //beskin tnc ingenious elva sincereskin
    //const payTypeId = 10; //citibella essentials
    //const payTypeId = 35; //marma ksparlour
    //const payTypeId = 30; //pureskin

    let {
      cardField,
      ewalletField,
      balance,
      selectedCards,
      isOpenSubPayment,
      prepaidTax,
      paidselected,
      billableamount,
      taxamt,
    } = this.state;
    /*
    selectedCards.push({
      pay_typeid: payTypeId,
      prepaid: true,
      pay_amt: userPayAmount,
      credit_debit: false,
      pay_premise: false,
      pay_rem1:
        selectedPrepaid.pp_no +
        " - " +
        selectedPrepaid.line_no +
        " - " +
        selectedPrepaid.pp_desc,
      pay_rem2: selectedPrepaid.id,
      pay_rem4: this.state.pay_rem4,
      prepaid_ct: selectedPrepaid.conditiontype1,
      pay_gst: 0,

    });
    console.log(
      "BeforeAdd-displayTablePrepaid",
      this.state.displayTablePrepaid
    );
    let setdisplayTablePrepaid = this.state.displayTablePrepaid;
    setdisplayTablePrepaid.push(selectedPrepaid.id);
    this.setState({ displayTablePrepaid: setdisplayTablePrepaid });
    console.log("AfterAdd-displayTablePrepaid", this.state.displayTablePrepaid);
    this.HidePrepaidTableData();
      */
    //balance = parseFloat(balance - userPayAmount).toFixed(2);

    console.log(
      "selectedRemainingPrepaidAmount",
      selectedRemainingPrepaidAmount
    );

    console.log("balance", balance);
    console.log("userpayamount 1", userPayAmount);
    //console.log("paidselected",paidselected);
    //Yoonus check balance against gst
    //if (
    //  this.state.responseData.is_exclusive &&
    //  this.state.responseData.gst_percent > 0
    //) {
    // }
    //bypass and check #Yoonus#
    if (
      this.state.responseData.is_exclusive &&
      this.state.responseData.gst_percent > 0 
      && 1==1
    ) {
      //responseData.deposit_amt
      console.log(
        "responseData.deposit_amt",
        this.state.responseData.deposit_amt
      );

      //var validamount = parseFloat(this.state.responseData.deposit_amt - paidselected);
      //if (parseFloat(selectedRemainingPrepaidAmount) >= parseFloat(validamount))  {
      //  userPayAmount = validamount;
      //  console.log("userpayamount 2",userPayAmount);
      //}
      balance = parseFloat(
        parseFloat(balance) - parseFloat(userPayAmount)
      ).toFixed(2);
      //var gstforthispayment = parseFloat(
      //  userPayAmount * (this.state.responseData.gst_percent / 100)
      //).toFixed(2);
      var gstforthispayment = parseFloat(
        (userPayAmount * ((100 + this.state.responseData.gst_percent) / 100)) - userPayAmount
      ).toFixed(2);
      console.log("gstforthispayment", gstforthispayment);

      //var gstforthispayment = parseFloat( (parseFloat(userPayAmount)/parseFloat(100 + this.state.responseData.gst_percent)) * parseFloat(this.state.responseData.gst_percent)  ).toFixed(2);
      console.log("BALANCE1", balance);
      //balance = parseFloat(balance - gstforthispayment).toFixed(2);
      balance = parseFloat(
        parseFloat(balance) - parseFloat(gstforthispayment)
      ).toFixed(2);
      console.log("BALANCE2", balance);
      if (parseFloat(balance) < 0) {
        if (parseFloat(balance) ==-0.01) {
          gstforthispayment = parseFloat(gstforthispayment-0.01).toFixed(2);          
        } else {
        gstforthispayment = parseFloat(
            (parseFloat(userPayAmount) /
              (this.state.responseData.gst_percent + 100)) *
              this.state.responseData.gst_percent
          ).toFixed(2);

           userPayAmount = parseFloat(
             parseFloat(userPayAmount) - parseFloat(gstforthispayment)
           ).toFixed(2);
        }
        //var gstdeductforthispayment = parseFloat( (parseFloat(userPayAmount) / (this.state.responseData.gst_percent+100)) * (this.state.responseData.gst_percent) ).toFixed(2);
        //console.log("gstdeductforthispayment",gstdeductforthispayment);
        //gstforthispayment = parseFloat(
        //  (parseFloat(userPayAmount) /
        //    (this.state.responseData.gst_percent + 100)) *
        //    this.state.responseData.gst_percent
        //).toFixed(2);
        console.log("gstforthispayment", gstforthispayment);
        balance = parseFloat(0).toFixed(2);

        //userPayAmount = parseFloat(
        //  parseFloat(userPayAmount) - parseFloat(gstforthispayment)
        //).toFixed(2);
        console.log("userPayAmount", userPayAmount);

      }
      //Yoonus
      if (parseFloat(balance) < 0.9 && 0 == parseFloat(this.state.roundingBalanceAmount)) {
        balance = parseFloat(0).toFixed(2);
      } else if (parseFloat(balance) == parseFloat(this.state.roundingBalanceAmount)) {
        balance = parseFloat(0).toFixed(2);
      }

      console.log("BALANCE3", balance);
      
      //billableamount = parseFloat(billableamount - gstforthispayment).toFixed(2);
      billableamount = parseFloat(
        parseFloat(billableamount) - parseFloat(gstforthispayment)
      ).toFixed(2);
      //prepaidTax = parseFloat(prepaidTax + gstforthispayment).toFixed(2);
      prepaidTax = parseFloat(
        parseFloat(prepaidTax) + parseFloat(gstforthispayment)
      ).toFixed(2);
      //taxamt = parseFloat(taxamt - gstforthispayment).toFixed(2);
      taxamt = parseFloat(
        parseFloat(taxamt) - parseFloat(gstforthispayment)
      ).toFixed(2);
      
    } else {
      balance = parseFloat(
        parseFloat(balance) - parseFloat(userPayAmount)
      ).toFixed(2);

      //taxamt = parseFloat(
      //  parseFloat(taxamt) - parseFloat(gstforthispayment)
      //).toFixed(2);

    }
    // prepaidCard list
    let prepaidCardsList = [];
    prepaidCardsList.push({
      pay_typeid: payTypeId,
      prepaid: true,
      pay_amt: parseFloat(userPayAmount),
      credit_debit: false,
      pay_premise: false,
      pay_rem1:
        selectedPrepaid.pp_no +
        " - " +
        selectedPrepaid.line_no +
        " - " +
        selectedPrepaid.pp_desc,
      pay_rem2: selectedPrepaid.id,
      pay_rem4: this.state.pay_rem4,
      prepaid_ct: selectedPrepaid.conditiontype1,
      pay_gst: 0,
      cartuse_ids: selectedPrepaid.cartuse_ids || [],
    });

    let prepaidPayload = {
      payment_box: selectedCards,
      total_cartuse_ids: this.state.preadidCartUseIds,
      selprepaid_cartids: selectedPrepaid.cartuse_ids,
      prepaid_id: selectedPrepaid?.id,
      pay_amt: selectedPrepaid?.redeem_amount,
    };

    let validatePrepaid = await this.handleToPrepaidValidation(prepaidPayload);

    if (validatePrepaid) {
      if (selectedCards.length > 0) {
        for (let updateList of prepaidCardsList) {
          let found = false;
          for (let i = 0; i < selectedCards.length; i++) {
            if (updateList.pay_rem1 === selectedCards[i].pay_rem1) {
              // Update the matched card item's data
              selectedCards[i] = updateList;
              found = true;
              break;
            }
          }
          if (!found) {
            selectedCards.push(updateList);
          }
        }
        this.setState({ selectedCards: selectedCards });
      } else {
        let mergeArrayList = [...this.state.selectedCards, ...prepaidCardsList];
        this.setState({ selectedCards: mergeArrayList });
      }

      // let mergeArrayList = [...this.state.selectedCards, ...prepaidCardsList];
      // this.setState({ selectedCards: mergeArrayList });
      // console.log("mergeArrayList", JSON.stringify(mergeArrayList));

      let setdisplayTablePrepaid = this.state.displayTablePrepaid;
      setdisplayTablePrepaid.push(selectedPrepaid.id);
      this.setState({ displayTablePrepaid: setdisplayTablePrepaid });
      // this.HidePrepaidTableData();
      paidselected = parseFloat(
        parseFloat(paidselected) + parseFloat(userPayAmount)
      ).toFixed(2);

      this.setBalanceToAllTextBoxes(balance);
      this.setState({
        isOpenSubPayment: false,
        prepaidTax: prepaidTax,
        paidselected: paidselected,
        billableamount: billableamount,
        taxamt: taxamt,
      });
    }
  };
  //   addPrepaid = async (selectedPrepaid) => {
  //     debugger;
  //     console.log("selectedPrepaid", JSON.stringify(selectedPrepaid));
  //     const prepaidExpDate = moment(selectedPrepaid.exp_date).format(
  //       "YYYY-MM-DD"
  //     );
  //     const todaysDate = moment(new Date()).format("YYYY-MM-DD");
  //     const isValid = moment(todaysDate).isSameOrAfter(prepaidExpDate);
  //     let userPayAmount = 0;
  //     let {
  //       itemServiceAmount,
  //       itemProductAmount,
  //       itemProductServiceVoucherAmount,
  //       txtUserPayAmount,
  //     } = this.state;
  //     console.log(txtUserPayAmount);
  //     userPayAmount = parseFloat(txtUserPayAmount);
  //     if (isValid) {
  //       Toast({
  //         type: "error",
  //         message: "Check Expiry Date",
  //       });
  //       return;
  //     }

  //     if (userPayAmount <= 0 || !selectedPrepaid?.is_allowprepaid) {
  //       Toast({
  //         type: "error",
  //         message: "Prepaid is Not allowed",
  //       });
  //       return;
  //     }

  //     // restrict prepaid value based on item
  //     // let totalCartUserIds = this.state.preadidCartUseIds;
  //     // let userSelectCartUseIds = selectedPrepaid.cartuse_ids;
  //     // let UserAllowstatus = false;
  //     // let TotalCartFilterIds = totalCartUserIds.filter((val) => {
  //     //   if (userSelectCartUseIds.includes(val)) {
  //     //     UserAllowstatus = true;
  //     //   }
  //     //   return !userSelectCartUseIds.includes(val);
  //     // });
  //     // if (UserAllowstatus) {
  //     //   this.setState({
  //     //     preadidCartUseIds: TotalCartFilterIds,
  //     //     BackupPreadidCartUseIds: TotalCartFilterIds,
  //     //   });
  //     // } else {
  //     //   Toast({
  //     //     type: "error",
  //     //     message: "Prepaid is Not allowed",
  //     //   });
  //     //   return;
  //     // }

  //     let selectedRemainingPrepaidAmount = parseFloat(
  //       selectedPrepaid.redeem_amount
  //     );
  //     //oldCode //let selectedRemainingPrepaidAmount = parseFloat(selectedPrepaid.remain);
  //     if (selectedRemainingPrepaidAmount < userPayAmount) {
  //       //return
  //     } else if (selectedRemainingPrepaidAmount > userPayAmount) {
  //       selectedRemainingPrepaidAmount = parseFloat(userPayAmount);
  //     }
  //     /*
  //     if (!this.validator.fieldValid("PrepaidBalanceAmount")) {
  //       this.validator.showMessageFor("PrepaidBalanceAmount");
  //       return;
  //     }
  //     if (!this.validator.fieldValid("PrepaidBalanceAmount")) {
  //       this.validator.showMessageFor("PrepaidBalanceAmount");
  //       return;
  //     }
  // */

  //     if (selectedPrepaid.conditiontype1 === "Service Only") {
  //       //For Service
  //       if (parseFloat(itemServiceAmount) === 0) {
  //         Toast({
  //           type: "error",
  //           message: "Prepaid is Not allowed",
  //         });
  //         return;
  //       }
  //       if (parseFloat(itemServiceAmount) <= selectedRemainingPrepaidAmount) {
  //         userPayAmount =
  //           parseFloat(txtUserPayAmount) < parseFloat(itemServiceAmount)
  //             ? parseFloat(txtUserPayAmount)
  //             : parseFloat(itemServiceAmount);
  //         console.log(itemServiceAmount);
  //         console.log(userPayAmount);
  //       } else {
  //         userPayAmount = selectedRemainingPrepaidAmount;
  //         console.log(userPayAmount);
  //       }
  //       itemServiceAmount = itemServiceAmount - userPayAmount;
  //       this.setState({ itemServiceAmount });
  //     } else if (selectedPrepaid.conditiontype1 === "Product Only") {
  //       //For Product
  //       if (parseFloat(itemProductAmount) === 0) {
  //         Toast({
  //           type: "error",
  //           message: "Prepaid is not allowed",
  //         });
  //         return;
  //       }
  //       if (parseFloat(itemProductAmount) <= selectedRemainingPrepaidAmount) {
  //         userPayAmount =
  //           parseFloat(txtUserPayAmount) < parseFloat(itemProductAmount)
  //             ? parseFloat(txtUserPayAmount)
  //             : parseFloat(itemProductAmount);
  //         console.log(userPayAmount);
  //       } else {
  //         userPayAmount = selectedRemainingPrepaidAmount;
  //         console.log(userPayAmount);
  //       }
  //       itemProductAmount = itemProductAmount - userPayAmount;
  //       this.setState({ itemProductAmount });
  //     } else {
  //       if (parseFloat(itemProductServiceVoucherAmount) === 0) {
  //         Toast({
  //           type: "error",
  //           message: "Prepaid is not allowed",
  //         });
  //         return;
  //       }
  //       if (
  //         parseFloat(itemProductServiceVoucherAmount) <=
  //         selectedRemainingPrepaidAmount
  //       ) {
  //         userPayAmount =
  //           parseFloat(txtUserPayAmount) <
  //           parseFloat(itemProductServiceVoucherAmount)
  //             ? parseFloat(txtUserPayAmount)
  //             : parseFloat(itemProductServiceVoucherAmount);
  //         console.log(userPayAmount);
  //       } else {
  //         userPayAmount = selectedRemainingPrepaidAmount;
  //         console.log(userPayAmount);
  //       }
  //       itemProductServiceVoucherAmount =
  //         itemProductServiceVoucherAmount - userPayAmount;
  //       this.setState({ itemProductServiceVoucherAmount });
  //     }
  //     if (userPayAmount == 0) {
  //       Toast({
  //         type: "error",
  //         message: "Prepaid is not allowed",
  //       });
  //       return;
  //     }

  //     //const payTypeId = 23; //normal twoherbs healspahq
  //     const payTypeId = this.getPayTableIdBasedOnPaygroupId(); //sensuous beauty21 appleskin jybeauty
  //     //const payTypeId = 7;  //skinsoul
  //     //const payTypeId = 8;  //glamour koiskin quantum magicion pixie demo skinhugs mydemo ch
  //     //const payTypeId = 12;   //destress avante bestbeauty cuttour synthesis sumi navis
  //     //const payTypeId = 13;   //impression
  //     //const payTypeId = 11; //embrace
  //     //const payTypeId = 9;  //beskin tnc ingenious elva sincereskin
  //     //const payTypeId = 10; //citibella essentials
  //     //const payTypeId = 35; //marma ksparlour
  //     //const payTypeId = 30; //pureskin

  //     let {
  //       cardField,
  //       ewalletField,
  //       balance,
  //       selectedCards,
  //       isOpenSubPayment,
  //       prepaidTax,
  //       paidselected,
  //       billableamount,
  //       taxamt,
  //     } = this.state;
  //     /*
  //     selectedCards.push({
  //       pay_typeid: payTypeId,
  //       prepaid: true,
  //       pay_amt: userPayAmount,
  //       credit_debit: false,
  //       pay_premise: false,
  //       pay_rem1:
  //         selectedPrepaid.pp_no +
  //         " - " +
  //         selectedPrepaid.line_no +
  //         " - " +
  //         selectedPrepaid.pp_desc,
  //       pay_rem2: selectedPrepaid.id,
  //       pay_rem4: this.state.pay_rem4,
  //       prepaid_ct: selectedPrepaid.conditiontype1,
  //       pay_gst: 0,

  //     });
  //     console.log(
  //       "BeforeAdd-displayTablePrepaid",
  //       this.state.displayTablePrepaid
  //     );
  //     let setdisplayTablePrepaid = this.state.displayTablePrepaid;
  //     setdisplayTablePrepaid.push(selectedPrepaid.id);
  //     this.setState({ displayTablePrepaid: setdisplayTablePrepaid });
  //     console.log("AfterAdd-displayTablePrepaid", this.state.displayTablePrepaid);
  //     this.HidePrepaidTableData();
  //       */
  //     //balance = parseFloat(balance - userPayAmount).toFixed(2);

  //     console.log(
  //       "selectedRemainingPrepaidAmount",
  //       selectedRemainingPrepaidAmount
  //     );

  //     console.log("balance", balance);
  //     console.log("userpayamount 1", userPayAmount);
  //     //console.log("paidselected",paidselected);
  //     //Yoonus check balance against gst
  //     if (
  //       this.state.responseData.is_exclusive &&
  //       this.state.responseData.gst_percent > 0
  //     ) {
  //       //responseData.deposit_amt
  //       console.log(
  //         "responseData.deposit_amt",
  //         this.state.responseData.deposit_amt
  //       );

  //       //var validamount = parseFloat(this.state.responseData.deposit_amt - paidselected);
  //       //if (parseFloat(selectedRemainingPrepaidAmount) >= parseFloat(validamount))  {
  //       //  userPayAmount = validamount;
  //       //  console.log("userpayamount 2",userPayAmount);
  //       //}
  //       balance = parseFloat(
  //         parseFloat(balance) - parseFloat(userPayAmount)
  //       ).toFixed(2);
  //       var gstforthispayment = parseFloat(
  //         userPayAmount * (this.state.responseData.gst_percent / 100)
  //       ).toFixed(2);
  //       //var gstforthispayment = parseFloat( (parseFloat(userPayAmount)/parseFloat(100 + this.state.responseData.gst_percent)) * parseFloat(this.state.responseData.gst_percent)  ).toFixed(2);
  //       console.log("gstforthispayment", gstforthispayment);

  //       //balance = parseFloat(balance - gstforthispayment).toFixed(2);
  //       balance = parseFloat(
  //         parseFloat(balance) - parseFloat(gstforthispayment)
  //       ).toFixed(2);
  //       if (parseFloat(balance) < 0) {
  //         balance = parseFloat(0).toFixed(2);
  //         //var gstdeductforthispayment = parseFloat( (parseFloat(userPayAmount) / (this.state.responseData.gst_percent+100)) * (this.state.responseData.gst_percent) ).toFixed(2);
  //         //console.log("gstdeductforthispayment",gstdeductforthispayment);
  //         gstforthispayment = parseFloat(
  //           (parseFloat(userPayAmount) /
  //             (this.state.responseData.gst_percent + 100)) *
  //             this.state.responseData.gst_percent
  //         ).toFixed(2);
  //         console.log("gstforthispayment", gstforthispayment);
  //         userPayAmount = parseFloat(
  //           parseFloat(userPayAmount) - parseFloat(gstforthispayment)
  //         ).toFixed(2);
  //         console.log("userPayAmount", userPayAmount);
  //       }

  //       //billableamount = parseFloat(billableamount - gstforthispayment).toFixed(2);
  //       billableamount = parseFloat(
  //         parseFloat(billableamount) - parseFloat(gstforthispayment)
  //       ).toFixed(2);
  //       //prepaidTax = parseFloat(prepaidTax + gstforthispayment).toFixed(2);
  //       prepaidTax = parseFloat(
  //         parseFloat(prepaidTax) + parseFloat(gstforthispayment)
  //       ).toFixed(2);
  //       //taxamt = parseFloat(taxamt - gstforthispayment).toFixed(2);
  //       taxamt = parseFloat(
  //         parseFloat(taxamt) - parseFloat(gstforthispayment)
  //       ).toFixed(2);
  //     } else {
  //       balance = parseFloat(
  //         parseFloat(balance) - parseFloat(userPayAmount)
  //       ).toFixed(2);
  //     }
  //     // prepaidCard list
  //     let prepaidCardsList = [];
  //     prepaidCardsList.push({
  //       pay_typeid: payTypeId,
  //       prepaid: true,
  //       pay_amt: parseFloat(userPayAmount),
  //       credit_debit: false,
  //       pay_premise: false,
  //       pay_rem1:
  //         selectedPrepaid.pp_no +
  //         " - " +
  //         selectedPrepaid.line_no +
  //         " - " +
  //         selectedPrepaid.pp_desc,
  //       pay_rem2: selectedPrepaid.id,
  //       pay_rem4: this.state.pay_rem4,
  //       prepaid_ct: selectedPrepaid.conditiontype1,
  //       pay_gst: 0,
  //       cartuse_ids: selectedPrepaid.cartuse_ids || [],
  //     });

  //     let prepaidPayload = {
  //       payment_box: selectedCards,
  //       total_cartuse_ids: this.state.preadidCartUseIds,
  //       selprepaid_cartids: selectedPrepaid.cartuse_ids,
  //       prepaid_id: selectedPrepaid?.id,
  //       pay_amt: selectedPrepaid?.oldRedeem_amount,
  //     };

  //     let validatePrepaid = await this.handleToPrepaidValidation(prepaidPayload);

  //     if (validatePrepaid) {
  //       console.log("prepaidCardsList", JSON.stringify(prepaidCardsList));
  //       console.log("selectedCards", JSON.stringify(selectedCards));
  //       if (selectedCards.length > 0) {
  //         for (let updateList of prepaidCardsList) {
  //           let found = false;
  //           for (let i = 0; i < selectedCards.length; i++) {
  //             if (updateList.pay_rem1 === selectedCards[i].pay_rem1) {
  //               // Update the matched card item's data
  //               selectedCards[i] = updateList;
  //               found = true;
  //               break;
  //             }
  //           }
  //           if (!found) {
  //             selectedCards.push(updateList);
  //           }
  //         }
  //         this.setState({ selectedCards: selectedCards });
  //       } else {
  //         let mergeArrayList = [...this.state.selectedCards, ...prepaidCardsList];
  //         this.setState({ selectedCards: mergeArrayList });
  //       }

  //       // let mergeArrayList = [...this.state.selectedCards, ...prepaidCardsList];
  //       // this.setState({ selectedCards: mergeArrayList });
  //       // console.log("mergeArrayList", JSON.stringify(mergeArrayList));

  //       let setdisplayTablePrepaid = this.state.displayTablePrepaid;
  //       setdisplayTablePrepaid.push(selectedPrepaid.id);
  //       this.setState({ displayTablePrepaid: setdisplayTablePrepaid });
  //       // this.HidePrepaidTableData();
  //       paidselected = parseFloat(
  //         parseFloat(paidselected) + parseFloat(userPayAmount)
  //       ).toFixed(2);

  //       this.setBalanceToAllTextBoxes(balance);
  //       this.setState({
  //         isOpenSubPayment: false,
  //         prepaidTax: prepaidTax,
  //         paidselected: paidselected,
  //         billableamount: billableamount,
  //         taxamt: taxamt,
  //       });
  //     }
  //   };

  // handlePrepaidValidtor
  handleToPrepaidValidation = async (prepaidPayload) => {
    var prepaidStatus = false;
    await this.props
      .commonCreateApi(`prepaidaccpaymentlist/validate/`, prepaidPayload)
      .then(async (key) => {
        let { status, data } = key;
        if (status === 200) {
          prepaidStatus = true;
        } else {
          prepaidStatus = false;
        }
      });
    return prepaidStatus;
  };

  HidePrepaidTableData() {
    let { prepaidCustomerData, displayTablePrepaid } = this.state;

    console.log("displayTablePrepaid", JSON.stringify(displayTablePrepaid));
    console.log("prepaidCustomerData", JSON.stringify(prepaidCustomerData));

    let filteredData = prepaidCustomerData.filter(
      (prepaid) => !displayTablePrepaid.includes(prepaid.id)
    );
    this.setState({ prepaidCustomerData: filteredData });
    // displayTablePrepaid.map((item) => {
    //   var selectedPrepaid = prepaidCustomerData.filter(
    //     (prepaid) => prepaid.id != item
    //   );
    //   this.setState({ prepaidCustomerData: selectedPrepaid });
    // });
  }
  HideCreditNoteTableDataOld() {
    let { creditNoteCustomerData, displayTableCreditNote } = this.state;

    console.log("first", JSON.stringify(creditNoteCustomerData));
    console.log("sec", JSON.stringify(displayTableCreditNote));

    // filterdata
    let filteredData = creditNoteCustomerData.filter(
      (item) => !displayTableCreditNote.includes(item.credit_code)
    );

    console.log("filterData", JSON.stringify(filteredData));
    this.setState({ creditNoteCustomerData: filteredData });

    // displayTableCreditNote.map((item) => {
    //   let selectedCreditNote = creditNoteCustomerData.filter(
    //     (creditNote) => creditNote.credit_code != item
    //   );

    //   console.log(selectedCreditNote, "selectedCreditnote");
    //   this.setState({ creditNoteCustomerData: selectedCreditNote });
    // });
  }
  HideCreditNoteTableData() {
    let { creditNoteCustomerData, displayTableCreditNote } = this.state;

    displayTableCreditNote.map((item) => {
      let selectedCreditNote = creditNoteCustomerData.filter(
        (creditNote) => creditNote.credit_code != item
      );

      console.log(selectedCreditNote, "selectedCreditnote");
      this.setState({ creditNoteCustomerData: selectedCreditNote });
    });
  }
  HideVoucherTableData() {
    let { voucherCustomerData, displayTableVoucher } = this.state;
    displayTableVoucher.map((item) => {
      var selectedVoucher = voucherCustomerData.filter(
        (voucher) => voucher.voucher_no != item
      );
      this.setState({ voucherCustomerData: selectedVoucher });
    });
  }
  addVoucher = (selectedVoucher) => {
    let {
      cardField,
      ewalletField,
      balance,
      txtUserPayAmount,
      isOpenSubPayment,
      selectedCards,
      voucherTax,
      paidselected,
      taxamt,
      billableamount,
    } = this.state;
    //Yoonus block this , allow 0 payment voucher for zenth, 12052024
    //if (txtUserPayAmount == 0) {
    //  Toast({
    //    type: "error",
    //    message: "Voucher is not allowed",
    //  });
    //  return;
   // }
    const selectedVoucherAmount = parseFloat(selectedVoucher.value);
    let pay_amt_setup = 0;
    if (selectedVoucherAmount <= parseFloat(txtUserPayAmount)) {
      pay_amt_setup = selectedVoucherAmount;
    } else {
      Toast({
        type: "error",
        message: "Partial Amount is not applicable in voucher",
      });
      return;
      // alert("Partial Amount is not applicable in voucher");
      // return;
    }

    //const payTypeId = 99; //Voucher Not available in paytable for pixie ch sincereskin
    //const payTypeId = 9; //normal healspahq
    //const payTypeId = 8; //sens beauty21 appleskin marmaclinic jybeauty
    const payTypeId = this.getPayTableIdBasedOnPaygroupId();
    //const payTypeId = 25; //twoherbs koiskin ingenious
    //const payTypeId = 3; //urbanspa
    //const payTypeId = 4; //glamour citibella skinsoul quantum
    //const payTypeId = 6; //destress embrace avante bestbeauty cuttour synthesis sumi impression navis essentials
    //const payTypeId = 5; //beskin tnc
    //const payTypeId = 26; //pureskin
    //const payTypeId = 32; //skinghugs
    //const payTypeId = 36; //ksaparlour
    //const payTypeId = 14; //elva
    //const payTypeId = 15; //demodb mydemo magicion
    /*
    selectedCards.push({
      pay_typeid: payTypeId,
      prepaid: false,
      pay_amt: parseFloat(pay_amt_setup),
      credit_debit: false,
      pay_premise: false,
      pay_rem1: selectedVoucher.voucher_no,
      pay_rem2: selectedVoucher.voucher_no,
      pay_rem4: this.state.pay_rem4,
      pay_gst: 0,
    });
    console.log(
      "BeforeAdd-displayTableVoucher",
      this.state.displayTableVoucher
    );
    let setdisplayTableVoucher = this.state.displayTableVoucher;
    setdisplayTableVoucher.push(selectedVoucher.voucher_no);
    this.setState({ displayTableVoucher: setdisplayTableVoucher });
    console.log(
      "AfterAdd-displayTableCreditNote",
      this.state.displayTableVoucher
    );
    this.HideVoucherTableData();
      */
    //balance = parseFloat(balance - pay_amt_setup).toFixed(2);

    //Yoonus check balance against gst
    if (
      this.state.responseData.is_exclusive &&
      this.state.responseData.gst_percent > 0
    ) {
      console.log(
        "responseData.deposit_amt",
        this.state.responseData.deposit_amt
      );
      var validamount = parseFloat(
        this.state.responseData.deposit_amt - paidselected
      );

      if (parseFloat(selectedVoucherAmount) >= parseFloat(validamount)) {
        pay_amt_setup = validamount;
        console.log("pay_amt_setup", pay_amt_setup);
      }
      balance = parseFloat(balance - pay_amt_setup).toFixed(2);

      var gstforthispayment = parseFloat(
        pay_amt_setup * (this.state.responseData.gst_percent / 100)
      ).toFixed(2);
      //var gstforthispayment = parseFloat( (parseFloat(pay_amt_setup)/parseFloat(100 + this.state.responseData.gst_percent)) * parseFloat(this.state.responseData.gst_percent)  ).toFixed(2);

      //balance = parseFloat(balance - gstforthispayment).toFixed(2);
      voucherTax = gstforthispayment;
      //taxamt = parseFloat(taxamt - gstforthispayment).toFixed(2);

      //balance = parseFloat(balance - gstforthispayment).toFixed(2);
      balance = parseFloat(
        parseFloat(balance) - parseFloat(gstforthispayment)
      ).toFixed(2);
      //billableamount = parseFloat(billableamount - gstforthispayment).toFixed(2);
      billableamount = parseFloat(
        parseFloat(billableamount) - parseFloat(gstforthispayment)
      ).toFixed(2);
      //taxamt = parseFloat(taxamt - gstforthispayment).toFixed(2);
      taxamt = parseFloat(
        parseFloat(taxamt) - parseFloat(gstforthispayment)
      ).toFixed(2);

      console.log(gstforthispayment);
    } else {
      //balance = parseFloat(balance - pay_amt_setup).toFixed(2);
      balance = parseFloat(
        parseFloat(balance) - parseFloat(pay_amt_setup)
      ).toFixed(2);
    }

    selectedCards.push({
      pay_typeid: payTypeId,
      prepaid: false,
      pay_amt: parseFloat(pay_amt_setup),
      credit_debit: false,
      pay_premise: false,
      pay_rem1: selectedVoucher.voucher_no,
      pay_rem2: selectedVoucher.voucher_no,
      pay_rem4: this.state.pay_rem4,
      pay_gst: 0,
    });
    console.log(
      "BeforeAdd-displayTableVoucher",
      this.state.displayTableVoucher
    );
    let setdisplayTableVoucher = this.state.displayTableVoucher;
    setdisplayTableVoucher.push(selectedVoucher.voucher_no);
    this.setState({ displayTableVoucher: setdisplayTableVoucher });
    console.log(
      "AfterAdd-displayTableCreditNote",
      this.state.displayTableVoucher
    );
    this.HideVoucherTableData();

    //paidselected = parseFloat(paidselected + pay_amt_setup).toFixed(2);
    paidselected = parseFloat(
      parseFloat(paidselected) + parseFloat(pay_amt_setup)
    ).toFixed(2);

    this.setBalanceToAllTextBoxes(balance);
    //console.log(balance);
    this.setState({
      isOpenSubPayment: false,
      voucherTax: voucherTax,
      paidselected: paidselected,
      taxamt: taxamt,
      billableamount: billableamount,
    });

    //Yoonus previous
    //this.setState({ isOpenSubPayment: false });
    //this.setBalanceToAllTextBoxes(balance);
  };

  addCreditNote = (selectedCreditNote) => {
    console.log(selectedCreditNote);
    let {
      cardField,
      ewalletField,
      balance,
      txtUserPayAmount,
      selectedCards,
      cnTax,
      paidselected,
      taxamt,
      billableamount,
    } = this.state;
    if (txtUserPayAmount == 0) {
      Toast({
        type: "error",
        message: "Credit Note is not allowed",
      });
      return;
    }
    const selectedCreditNoteAmount = parseFloat(selectedCreditNote.balance);
    console.log(selectedCreditNoteAmount);
    let pay_amt_setup = 0;
    if (selectedCreditNoteAmount <= parseFloat(txtUserPayAmount)) {
      pay_amt_setup = selectedCreditNoteAmount;
    } else {
      pay_amt_setup = txtUserPayAmount;
    }
    //const payTypeId = 17; //normal healspahq
    //const payTypeId = 24; //twoherbs
    //const payTypeId = 12; //healspa sens beauty21 appleskin marma jybeauty ksparlour
    const payTypeId = this.getPayTableIdBasedOnPaygroupId();
    //const payTypeId = 14; //citibella
    //const payTypeId = 5; //glamour skinsoul koiskin quantum
    //const payTypeId = 6; //beskin tnc ingenious magicion pixie demo skinhugs elva mydemo ch sincere
    //const payTypeId = 8; //destress embrace avante bestbeauty cuttour synthesis sumi impression navis
    //const payTypeId = 27; //Pureskin
    //const payTypeId = 7; //essentials
    /*
    selectedCards.push({
      pay_typeid: payTypeId,
      prepaid: false,
      pay_amt: parseFloat(pay_amt_setup),
      credit_debit: false,
      pay_premise: false,
      pay_rem1: selectedCreditNote.credit_code,
      pay_rem2: selectedCreditNote.transaction,
      pay_rem4: this.state.pay_rem4,
      pay_gst: 0,

    });
    console.log(
      "BeforeAdd-displayTableCreditNote",
      this.state.displayTableCreditNote
    );
    let setdisplayTableCreditNote = this.state.displayTableCreditNote;
    setdisplayTableCreditNote.push(selectedCreditNote.credit_code);
    this.setState({ displayTableCreditNote: setdisplayTableCreditNote });
    console.log(
      "AfterAdd-displayTableCreditNote",
      this.state.displayTableCreditNote
    );
    this.HideCreditNoteTableData();
      */
    //balance = parseFloat(balance - pay_amt_setup).toFixed(2);

    //Yoonus check balance against gst
    if (
      this.state.responseData.is_exclusive &&
      this.state.responseData.gst_percent > 0
    ) {
      console.log(
        "responseData.deposit_amt",
        this.state.responseData.deposit_amt
      );
      var validamount = parseFloat(
        this.state.responseData.deposit_amt - paidselected
      );
      if (parseFloat(selectedCreditNoteAmount) >= parseFloat(validamount)) {
        pay_amt_setup = validamount;
        console.log("userpayamount", pay_amt_setup);
      }
      balance = parseFloat(balance - pay_amt_setup).toFixed(2);

      var gstforthispayment = parseFloat(
        pay_amt_setup * (this.state.responseData.gst_percent / 100)
      ).toFixed(2);
      //var gstforthispayment = parseFloat( (parseFloat(pay_amt_setup)/parseFloat(100 + this.state.responseData.gst_percent)) * parseFloat(this.state.responseData.gst_percent)  ).toFixed(2);

      //balance = parseFloat(balance - gstforthispayment).toFixed(2);
      cnTax = gstforthispayment;
      //taxamt = parseFloat(taxamt - gstforthispayment).toFixed(2);
      //balance = parseFloat(balance - gstforthispayment).toFixed(2);
      balance = parseFloat(
        parseFloat(balance) - parseFloat(gstforthispayment)
      ).toFixed(2);
      //billableamount = parseFloat(billableamount - gstforthispayment).toFixed(2);
      billableamount = parseFloat(
        parseFloat(billableamount) - parseFloat(gstforthispayment)
      ).toFixed(2);
      //taxamt = parseFloat(taxamt - gstforthispayment).toFixed(2);
      taxamt = parseFloat(
        parseFloat(taxamt) - parseFloat(gstforthispayment)
      ).toFixed(2);

      console.log(gstforthispayment);
    } else {
      //balance = parseFloat(balance - pay_amt_setup).toFixed(2);
      balance = parseFloat(
        parseFloat(balance) - parseFloat(pay_amt_setup)
      ).toFixed(2);
    }

    selectedCards.push({
      pay_typeid: payTypeId,
      prepaid: false,
      pay_amt: parseFloat(pay_amt_setup),
      credit_debit: false,
      pay_premise: false,
      pay_rem1: selectedCreditNote.credit_code,
      pay_rem2: selectedCreditNote.transaction,
      pay_rem4: this.state.pay_rem4,
      pay_gst: 0,
    });

    let setdisplayTableCreditNote = this.state.displayTableCreditNote;
    setdisplayTableCreditNote.push(selectedCreditNote.credit_code);
    this.setState({ displayTableCreditNote: setdisplayTableCreditNote }, () => {
      this.HideCreditNoteTableData();
    });

    //paidselected = parseFloat(paidselected + pay_amt_setup).toFixed(2);
    paidselected = parseFloat(
      parseFloat(paidselected) + parseFloat(pay_amt_setup)
    ).toFixed(2);

    this.setBalanceToAllTextBoxes(balance);
    //console.log(balance);
    this.setState({
      isOpenSubPayment: false,
      cnTax: cnTax,
      paidselected: paidselected,
      taxamt: taxamt,
      billableamount: billableamount,
    });

    //Yoonus previous one
    //this.setState({ isOpenSubPayment: false });
    //this.setBalanceToAllTextBoxes(balance);
  };

  setBalanceToAllTextBoxes(balance) {
    var txtUserPayAmount = parseFloat(
      parseFloat(balance) + parseFloat(this.state.roundingBalanceAmount)
    ).toFixed(2);

    console.log("balance", balance);
    console.log("rounding", this.state.roundingBalanceAmount);

    this.setState({
      balance: balance,
      txtUserPayAmount: txtUserPayAmount,
    });
    //this.setState({
    //  balance: balance,
    //  txtUserPayAmount: balance,
    //});
  }

  addOldBill = async () => {
    let {
      cardField,
      ewalletField,
      balance,
      txtUserPayAmount,
      selectedCards,
      oldbillTax,
      paidselected,
      taxamt,
      billableamount,
    } = this.state;
    console.log("txtUserPayAmount", txtUserPayAmount);

    //const payTypeId = 29; //normal healspahq
    //const payTypeId = 22; //twoherbs
    //const payTypeId = 13; //healspa sens beauty21 appleskin citibella marma ksparlour
    //const payTypeId = 11; //glamour skinsoul koiskin quantum sincere
    //const payTypeId = 8; // skinsoul
    //const payTypeId = 10; //beskin tnc ingenious magicion pixie demo elva
    //const payTypeId = 13; //avante Synthesis sumi riversameasavante navis bestbeauty embrace
    //const payTypeId = 12; //essentials
    //const payTypeId = 14; //impression
    //const payTypeId = 9; //mydemo ch skinhugs
    //const payTypeId = 24; //jybeauty
    const payTypeId = this.getPayTableIdBasedOnPaygroupId();

    if (this.checkPayTypeIdAlreadyExists(payTypeId)) {
      let result = this.getPayTableNameBasedOnId(payTypeId) + " already exists";
      Toast({
        type: "error",
        message: result,
      });
      return;
    } else {
      console.log("addoldbill");

      let pay_amt_setup = parseFloat(txtUserPayAmount);

      //Yoonus check balance against gst
      if (
        this.state.responseData.is_exclusive &&
        this.state.responseData.gst_percent > 0
      ) {
        console.log(
          "responseData.deposit_amt",
          this.state.responseData.deposit_amt
        );

        balance = parseFloat(
          parseFloat(balance) - parseFloat(pay_amt_setup)
        ).toFixed(2);
        console.log("pay_amt_setup", pay_amt_setup);
        var gstforthispayment = parseFloat(
          pay_amt_setup * (this.state.responseData.gst_percent / 100)
        ).toFixed(2);
        console.log("gstforthispayment", gstforthispayment);
        balance = parseFloat(
          parseFloat(balance) - parseFloat(gstforthispayment)
        ).toFixed(2);
        if (parseFloat(balance) < 0) {
          balance = parseFloat(0).toFixed(2);
          gstforthispayment = parseFloat(
            (parseFloat(pay_amt_setup) /
              (this.state.responseData.gst_percent + 100)) *
              this.state.responseData.gst_percent
          ).toFixed(2);
          console.log("gstforthispayment", gstforthispayment);
          pay_amt_setup = parseFloat(
            parseFloat(pay_amt_setup) - parseFloat(gstforthispayment)
          ).toFixed(2);
          console.log("userPayAmount", pay_amt_setup);
        }
        billableamount = parseFloat(
          parseFloat(billableamount) - parseFloat(gstforthispayment)
        ).toFixed(2);
        oldbillTax = parseFloat(
          parseFloat(oldbillTax) + parseFloat(gstforthispayment)
        ).toFixed(2);
        taxamt = parseFloat(
          parseFloat(taxamt) - parseFloat(gstforthispayment)
        ).toFixed(2);
      } else {
        balance = parseFloat(
          parseFloat(balance) - parseFloat(pay_amt_setup)
        ).toFixed(2);
      }

      //Yoonus
      if (parseFloat(balance) < 0.9 && 0 == parseFloat(this.state.roundingBalanceAmount)) {
        balance = parseFloat(0).toFixed(2);
      } else if (parseFloat(balance) == parseFloat(this.state.roundingBalanceAmount)) {
        balance = parseFloat(0).toFixed(2);
      }
      
      selectedCards.push({
        pay_typeid: payTypeId,
        prepaid: false,
        pay_amt: parseFloat(pay_amt_setup),
        credit_debit: false,
        pay_premise: false,
        pay_gst: 0,
        pay_rem4: this.state.pay_rem4,
      });

      paidselected = parseFloat(
        parseFloat(paidselected) + parseFloat(pay_amt_setup)
      ).toFixed(2);

      this.setBalanceToAllTextBoxes(balance);
      this.setState({
        isOpenSubPayment: false,
        oldbillTax: oldbillTax,
        paidselected: paidselected,
        taxamt: taxamt,
        billableamount: billableamount,
      });
    }
  };

  removeCards = (idx) => () => {
    console.log("removeData", idx);

    let {
      responseData,
      selectedCards,
      balance,
      cardField,
      ewalletField,
      itemProductServiceVoucherAmount,
      itemProductAmount,
      itemServiceAmount,
      cnTax,
      prepaidTax,
      voucherTax,
      oldbillTax,
      paidselected,
      billableamount,
      taxamt,
      txtUserPayAmount,
      roundingBalanceAmount,
    } = this.state;
    console.log(responseData, "responseData");
    this.setState({ isMakePaymentButtonClicked: "false" });
    balance = parseFloat(parseFloat(balance) + parseFloat(idx.pay_amt)).toFixed(
      2
    );
    var array = [...selectedCards]; // make a separate copy of the array
    var index = array.indexOf(idx);
    paidselected = parseFloat(
      parseFloat(paidselected) - parseFloat(idx.pay_amt)
    ).toFixed(2);
    console.log("paidselected", paidselected);
    console.log(idx.pay_is_rounding);
    if (idx.pay_is_rounding == 1) {
      //txtUserPayAmount = parseFloat( parseFloat(txtUserPayAmount) - parseFloat(roundingBalanceAmount) ).toFixed(2);
      roundingBalanceAmount = 0;
    }
    //if (idx.pay_typeid == 23) { //normal twoherbs healspahq
    //if (idx.pay_typeid == 19) {
    //healspa sens beauty21 appleskin jybeauty esthetic emmabelle
    //if (idx.pay_typeid == 35) { //marmaclinic ksparlour
    //if (idx.pay_typeid == 7) { //skinsoul studio a
    //if (idx.pay_typeid == 12) { //destress avante bestbeauty cuttour synthesis sumi navis
    //if (idx.pay_typeid == 13) { //impression
    //if (idx.pay_typeid == 11) { //embrace
    //if (idx.pay_typeid == 8) { //glamour koiskin quantum magicion pixie demo skinhugs ch f21
    //if (idx.pay_typeid == 10) { //citibella Essentials risespa oceanleaf 
    //if (idx.pay_typeid == 9) {
      //beskin tnc ingenious elva sincere ot
      //if (idx.pay_typeid == 30) { //pureskin
      //if (idx.pay_typeid == 15) { //demodb mydemo
      if (idx.pay_typeid == 22) {
      //salonone kirei luxelle crystal
      if (idx.prepaid_ct == "Product Only") {
        itemProductAmount = itemProductAmount + idx.pay_amt;
      } else if (idx.prepaid_ct == "Service Only") {
        itemServiceAmount = itemServiceAmount + idx.pay_amt;
      } else {
        itemProductServiceVoucherAmount =
          itemProductServiceVoucherAmount + idx.pay_amt;
      }
      this.setState({
        itemProductServiceVoucherAmount,
        itemProductAmount,
        itemServiceAmount,
      });
    }
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ selectedCards: array, balance });
    }
    //console.log("idx", idx);
    var removedTerm = idx.pay_typeid;
    console.log(removedTerm, "removedTerm");
    //console.log("idx.pay_rem2", idx.pay_rem2);

    //if (removedTerm == "23") { //normal twoherbs healspahq
    //if (removedTerm == "19") {
    //healspa sens beauty21 appleskin jybeauty esthetic emmabelle
    //if (removedTerm == "35") { //marma
    //if (removedTerm == "12") { //destress avante bestbeauty cuttour synthesis sumi navis
    //if (removedTerm == "13") { //impression
    //if (removedTerm == "11") { //embrace
    //if (removedTerm == "7") { //skinsoul studioa
    //if (removedTerm == "8") { //glamour koiskin quantum magicion pixie demo skinhugs mydemo ch f21
    //if (removedTerm == "9") {
      //beskin tnc ingenious elva sincere ot
      //if (removedTerm == "10") { //citibella Essentials risespa oceanleaf
      //if (removedTerm == "30") { //pureskin
      if (removedTerm == "22") {
      //salonone kirei luxelle crystal
      const items = this.state.displayTablePrepaid;
      console.log("BeforeRemove-displayTablePrepaid", items);
      const valueToRemove = idx.pay_rem2; //For Prepaid Ony we have added unique id here
      console.log("BeforeRemove-valueToRemove", valueToRemove);
      const filteredItems = items.filter((item) => item !== valueToRemove);
      this.setState({ displayTablePrepaid: filteredItems }, () => {
        console.log(
          "AfterRemove-displayTablePrepaid",
          this.state.displayTablePrepaid
        );
      });
      console.log("prepaidTax", prepaidTax);
      balance = parseFloat(
        parseFloat(balance) + parseFloat(prepaidTax)
      ).toFixed(2);
      billableamount = parseFloat(
        parseFloat(billableamount) + parseFloat(prepaidTax)
      ).toFixed(2);
      taxamt = parseFloat(parseFloat(taxamt) + parseFloat(prepaidTax)).toFixed(
        2
      );
      prepaidTax = 0;
      this.setState({
        prepaidTax: prepaidTax,
      });
      console.log("balance", balance);
      console.log("billableamount", billableamount);

      if (idx?.prepaid) {
        // let payload = {
        //   // prepaid_id: idx?.pay_rem2,
        //   prepaid_id: 1200399,
        // };
        //alert(payload);

        this.props
          .commonDeleteApi(
            `prepaidaccpaymentlist/delete/?prepaid_id=${idx?.pay_rem2}`
          )
          .then(async (key) => {
            let { status, data } = key;

            let setdisplayTablePrepaid = [];
            await this.setState({
              displayTablePrepaid: setdisplayTablePrepaid,
            });
            this.getPrepaidAccountData("");
          });
      } else {
        this.getPrepaidAccountData("");
      }
      // this.HidePrepaidTableData();
    }

    //if (removedTerm == "17") { //normal healspahq
    //if (removedTerm == "24") { //twoherbs
    //if (removedTerm == "12") {
    //healspa sens beauty21 appleskin marma jybeauty ksparlour
    //if (removedTerm == "14") { //citibella
    if (removedTerm == "10") {
    //salonone kirei luxelle crystal monarch aplussameas salon
    //if (removedTerm == "12") { //esthetic emmabelle
    //if (removedTerm == "5") { //glamour skinsoul koiskin quantum studioa
    //if (removedTerm == "6") {
      //beskin tnc ingenious magicion pixie demo skinhugs elva mydemo ch sincere f21 ot
      //if (removedTerm == "8") { //destress embrace avante bestbeauty cuttour synthesis sumi impression navis
      //if (removedTerm == "7") { //Essentials risespa
      //if (removedTerm == "2") { //oceanleaf
      //if (removedTerm == "27") { //pureskin
      const items = this.state.displayTableCreditNote;
      console.log("BeforeRemove-displayTableCreditNote", items);
      const valueToRemove = idx.pay_rem1; //For Credit Note Ony we have added unique id here
      console.log("BeforeRemove-valueToRemove", valueToRemove);
      const filteredItems = items.filter((item) => item !== valueToRemove);
      this.setState({ displayTableCreditNote: filteredItems }, () => {
        console.log(
          "AfterRemove-displayTableCreditNote",
          this.state.displayTableCreditNote
        );
      });
      //balance = parseFloat(balance) + parseFloat(cnTax);
      balance = parseFloat(parseFloat(balance) + parseFloat(cnTax)).toFixed(2);
      billableamount = parseFloat(
        parseFloat(billableamount) + parseFloat(cnTax)
      ).toFixed(2);
      taxamt = parseFloat(parseFloat(taxamt) + parseFloat(cnTax)).toFixed(2);
      cnTax = 0;
      this.setState({
        cnTax: cnTax,
      });

      this.getCreditNoteAccountData("");
      // this.HidePrepaidTableData();
    }

    if (removedTerm == "99") { //Not available in paytable for pixie ch sincere f21 luxelle ocean kirei
    //if (removedTerm == "9") { //normal healspahq studioa
    //if (removedTerm == "25") { //twoherbs koiskin ingenious
    //if (removedTerm == "23") {
    //salonone
    //if (removedTerm == "18") { //esthetic
    //if (removedTerm == "13") { //ot
    //if (removedTerm == "8") {
    //healspa sens beauty21 appleskin marma jybeauty
    //if (removedTerm == "4") { //glamour citibella skinsoul quantum
    //if (removedTerm == "6") { //destress Embrace avante bestbeauty cuttour synthesis sumi impression
    //navis essentials risespa
    //if (removedTerm == "5") {
      //beskin tnc
      //if (removedTerm == "26") { //pureskin
      //if (removedTerm == "32") { //skinhugs
      //if (removedTerm == "36") { //ksparlour
      //if (removedTerm == "10") { //emmabelle
      //if (removedTerm == "14") { //elva
      //if (removedTerm == "15") { //demodb mydemo magicion
      const items = this.state.displayTableVoucher;
      console.log("BeforeRemove-displayTableVoucher", items);
      const valueToRemove = idx.pay_rem1; //For Credit Note Ony we have added unique id here
      console.log("BeforeRemove-valueToRemove", valueToRemove);
      const filteredItems = items.filter((item) => item !== valueToRemove);
      this.setState({ displayTableVoucher: filteredItems }, () => {
        console.log(
          "AfterRemove-displayTableVoucher",
          this.state.displayTableVoucher
        );
      });
      //balance = parseFloat(balance) + parseFloat(voucherTax);
      balance = parseFloat(
        parseFloat(balance) + parseFloat(voucherTax)
      ).toFixed(2);
      billableamount = parseFloat(
        parseFloat(billableamount) + parseFloat(voucherTax)
      ).toFixed(2);
      taxamt = parseFloat(parseFloat(taxamt) + parseFloat(voucherTax)).toFixed(
        2
      );
      voucherTax = 0;
      this.setState({
        voucherTax: voucherTax,
      });
      this.getVoucherData("");
    }

    //Oldbill
    //if (removedTerm == "22") { //twoherbs
    //if (removedTerm == "14") { //impression
    //if (removedTerm == "11") { //glamour sincere
    //if (removedTerm == "10") {
      //impression f21 tnc ot
      //if (removedTerm == "13") { //avante synthesis sumi riversameasavante ch navis bestbeauty embrace
      //if (removedTerm == "24") {  //jybeauty Essentials Emmabelle
      //if (removedTerm == "9") { //mydemo ch
      //if (removedTerm == "8") { //studioa
      if (removedTerm == "17") {
      //salonone kirei luxelle monarch
      //if (removedTerm == "24") { //esthetic
      //if (removedTerm == "12") { //risespa
      //if (removedTerm == "4") { //oceanleaf
      console.log("balance", balance);
      balance = parseFloat(
        parseFloat(balance) + parseFloat(oldbillTax)
      ).toFixed(2);
      console.log("balance", balance);
      console.log("billableamount", billableamount);
      billableamount = parseFloat(
        parseFloat(billableamount) + parseFloat(oldbillTax)
      ).toFixed(2);
      console.log("billableamount", billableamount);
      console.log("taxamt", taxamt);
      taxamt = parseFloat(parseFloat(taxamt) + parseFloat(oldbillTax)).toFixed(
        2
      );
      console.log("taxamt", taxamt);
      oldbillTax = 0;
      this.setState({
        oldbillTax: oldbillTax,
      });
    }

    if (removedTerm == "25") {
      const items = this.state.displayTablePoint;
      console.log("BeforeRemove-displayTablePoint", items);
      const valueToRemove = idx.pay_rem2; //For Prepaid Ony we have added unique id here
      console.log("BeforeRemove-valueToRemove", valueToRemove);
      const filteredItems = items.filter((item) => item !== valueToRemove);
      this.setState({ displayTablePoint: filteredItems }, () => {
        console.log(
          "AfterRemove-displayTablePoint",
          this.state.displayTablePoint
        );
      });
      this.getPointData();
      // this.HidePrepaidTableData();
    }

    cardField["pay_amt"] = balance;
    ewalletField["pay_amt"] = balance;
    console.log(paidselected);
    console.log(billableamount);
    console.log("paidselected remove", paidselected);

    if (index !== -1) {
      //array.splice(index, 1);

      console.log("not empty");

      if (array.length === 0) {
        console.log("empty rest");
        cnTax = 0;
        prepaidTax = 0;
        voucherTax = 0;
        oldbillTax = 0;
        paidselected = 0;

        balance = Number(responseData.billable_amount);
        txtUserPayAmount = Number(responseData.billable_amount);
        billableamount = Number(responseData.billable_amount);
        taxamt = Number(responseData.tax_amt);
        console.log(txtUserPayAmount, "txtUserPayAmount1");

        this.setState({
          txtUserPayAmount,
          cnTax,
          prepaidTax,
          voucherTax,
          oldbillTax,
        });
      } else {
        txtUserPayAmount = parseFloat(
          parseFloat(balance) + parseFloat(roundingBalanceAmount)
        ).toFixed(2);
        if (parseFloat(txtUserPayAmount) < 0) {
          txtUserPayAmount = 0;
        }
        console.log("txtUserPayAmount remove", txtUserPayAmount);
        //this.setState({
        //  txtUserPayAmount: txtUserPayAmount,
        //});
      }

      //this.setState({ selectedCards: array, balance });
    }

    //this.setState({
    //  paidselected: paidselected, billableamount: billableamount, taxamt: taxamt,
    //});
    this.setState({
      paidselected,
      billableamount,
      taxamt,
      roundingBalanceAmount,
    });
    // Added Amount with Gst Value by Santhosh
    if (idx.pay_gst === 0 && array.length !== 0) {
      let newUserAmount = parseFloat(
        parseFloat(balance) + parseFloat(roundingBalanceAmount)
      ).toFixed(2);
      let gstUserAmount = (txtUserPayAmount * responseData.gst_percent) / 100;
      txtUserPayAmount = Number(newUserAmount) + Number(gstUserAmount);
      this.setState({ txtUserPayAmount, balance: txtUserPayAmount });
    } else {
      this.setBalanceToAllTextBoxes(balance);
    }
  };
  checkTypeOfCartItemContainsDeposit(cartData) {
    let stringifiedCartData = cartData.data;
    if (stringifiedCartData) {
      stringifiedCartData.map((item) => {
        if (item.type === "Deposit" || item.type === "Top Up") {
          this.state.isTreatmentDoneButton = false;
        }
      });
    }
  }

  //for GT2 update, method update shared by yoonus
  addOldBillNewMethod = (async) => {
    let {
      cardField,
      ewalletField,
      balance,
      txtUserPayAmount,
      selectedCards,
      oldbillTax,
      paidselected,
      taxamt,
      billableamount,
    } = this.state;
    console.log("txtUserPayAmount", txtUserPayAmount);

    //const payTypeId = 29; //normal healspahq
    //const payTypeId = 22; //twoherbs
    //const payTypeId = 13; //healspa sens beauty21 appleskin citibella marma jybeauty ksparlour
    //const payTypeId = 11; //glamour skinsoul koiskin quantum
    //const payTypeId = 8; // skinsoul
    //const payTypeId = 10; //beskin tnc ingenious magicion pixie demo skinhugs elva
    //const payTypeId = 13; //avante Synthesis sumi riversameasavante ch
    //const payTypeId = 14; //impression
    //const payTypeId = 24; //jybeauty
    const payTypeId = this.getPayTableIdBasedOnPaygroupId();
    //const payTypeId = 9; //mydemo

    if (this.checkPayTypeIdAlreadyExists(payTypeId)) {
      let result = this.getPayTableNameBasedOnId(payTypeId) + " already exists";
      Toast({
        type: "error",
        message: result,
      });
      return;
    } else {
      console.log("addoldbill");

      let pay_amt_setup = parseFloat(txtUserPayAmount);

      //Yoonus check balance against gst
      if (
        this.state.responseData.is_exclusive &&
        this.state.responseData.gst_percent > 0
      ) {
        console.log(
          "responseData.deposit_amt",
          this.state.responseData.deposit_amt
        );

        balance = parseFloat(
          parseFloat(balance) - parseFloat(pay_amt_setup)
        ).toFixed(2);
        var gstforthispayment = parseFloat(
          pay_amt_setup * (this.state.responseData.gst_percent / 100)
        ).toFixed(2);
        console.log("gstforthispayment", gstforthispayment);
        balance = parseFloat(
          parseFloat(balance) - parseFloat(gstforthispayment)
        ).toFixed(2);
        if (parseFloat(balance) < 0) {
          balance = parseFloat(0).toFixed(2);
          gstforthispayment = parseFloat(
            (parseFloat(pay_amt_setup) /
              (this.state.responseData.gst_percent + 100)) *
              this.state.responseData.gst_percent
          ).toFixed(2);
          console.log("gstforthispayment", gstforthispayment);
          pay_amt_setup = parseFloat(
            parseFloat(pay_amt_setup) - parseFloat(gstforthispayment)
          ).toFixed(2);
          console.log("userPayAmount", pay_amt_setup);
        }
        billableamount = parseFloat(
          parseFloat(billableamount) - parseFloat(gstforthispayment)
        ).toFixed(2);
        oldbillTax = parseFloat(
          parseFloat(oldbillTax) + parseFloat(gstforthispayment)
        ).toFixed(2);
        taxamt = parseFloat(
          parseFloat(taxamt) - parseFloat(gstforthispayment)
        ).toFixed(2);
      } else {
        balance = parseFloat(
          parseFloat(balance) - parseFloat(pay_amt_setup)
        ).toFixed(2);
      }

      selectedCards.push({
        pay_typeid: payTypeId,
        prepaid: false,
        pay_amt: parseFloat(pay_amt_setup),
        credit_debit: false,
        pay_premise: false,
        pay_gst: 0,
        pay_rem4: this.state.pay_rem4,
      });

      paidselected = parseFloat(
        parseFloat(paidselected) + parseFloat(pay_amt_setup)
      ).toFixed(2);

      this.setBalanceToAllTextBoxes(balance);
      this.setState({
        isOpenSubPayment: false,
        oldbillTax: oldbillTax,
        paidselected: paidselected,
        taxamt: taxamt,
        billableamount: billableamount,
      });
    }
  };

  addNewPaymentData = async (selPayTypeId, selPayTypeName) => {
    let { paytableFullData, selectedPaygroupId } = this.state;

    if (!this.validator.fieldValid("Amount")) {
      this.validator.showMessageFor("Amount");
      return;
    }
    if (!this.validator.fieldValid("Amount")) {
      this.validator.showMessageFor("Amount");
      return;
    }
    this.setState({
      isSelectedPaymentType: selPayTypeName.trim(),
      selectedPaygroupId: selPayTypeId,
    });
    this.props
      .getCommonApi(`paytablenew/?paygroupid=${selPayTypeId}`)
      .then((res) => {
        this.setState({
          paytableData: [],
        });

        let { paytableData, isSelectedPaymentType, displayModelPaymentType } =
          this.state;
        isSelectedPaymentType = selPayTypeName.trim().toUpperCase();
        displayModelPaymentType = selPayTypeName.trim().toUpperCase();
        for (let key of res.data) {
          paytableData.push({
            label: key.pay_description,
            value: key.id,
            rounding: key.pay_is_rounding,
            gt_group: key?.gt_group ?? "",
            payimage: key?.paytypeimage ? key?.paytypeimage : cardIcon,
            paykey: key?.paykey,
            qr_code: key?.qr_code ?? "",
          });
        }

        // else if (
        //   selPayTypeName.trim().toUpperCase() === "ONLINE PAYMENT"
        // ) {
        //   isOpenSubPayment = true;
        // }

        this.setState(
          {
            paytableData,
          },
          () => {
            let { isOpenSubPayment } = this.state;
            if (paytableData.length == 0) {
              Toast({
                type: "error",
                message: "Pay Table Not Exists",
              });
              return;
            } else if (selPayTypeName.trim().toUpperCase() === "VOUCHER") {
              isOpenSubPayment = true;
            } else if (selPayTypeName.trim().toUpperCase() === "POINT") {
              isOpenSubPayment = true;
            } else if (selPayTypeName.trim().toUpperCase() === "PREPAID") {
              this.getPrepaidData();
              isOpenSubPayment = true;
            } else if (
              selPayTypeName.trim().toUpperCase() === "ONLINE PAYMENT"
            ) {
              isOpenSubPayment = true;
            } else if (selPayTypeName.trim().toUpperCase() === "CREDIT") {
              isOpenSubPayment = true;
            } else if (
              selPayTypeName.trim().toUpperCase() == "MEMBER VOUCHER"
            ) {
              this.setState({
                memberVoucherNumber: "",
              });
              isOpenSubPayment = true;
            } else if (selPayTypeName.trim().toUpperCase() === "CARD") {
              isOpenSubPayment = true;
            } else if (
              selPayTypeName.trim().toUpperCase() === "ONLINE PAYMENT"
            ) {
              isOpenSubPayment = true;
            } else if (selPayTypeName.trim().toUpperCase() === "OLD BILL") {
              isOpenSubPayment = false;
              console.log("oldbill");
              this.addOldBill();
              return;
            } else if (paytableData[0]?.gt_group == "GT2") {
              isOpenSubPayment = false;
              this.addOldBillNewMethod();
              return;
            } else if (paytableData.length == 1) {
              isOpenSubPayment = false;
              let payTypeId = paytableData[0].value;

              let {
                balance,
                selectedCards,
                txtUserPayAmount,
                paidselected,
                billableamount,
                prepaidTax,
                cnTax,
                voucherTax,
                roundingBalanceAmount,
              } = this.state;
              if (parseFloat(this.state.responseData.billable_amount) > 0) {
                if (parseFloat(txtUserPayAmount) == 0) {
                  return;
                }
              }

              if (this.checkPayTypeIdAlreadyExists(payTypeId)) {
                let result =
                  this.getPayTableNameBasedOnId(payTypeId) + " already exists";
                Toast({
                  type: "error",
                  message: result,
                });

                return;
              } else {
                console.log("addnewPayment", paytableData[0].rounding);
                //paidselected = parseFloat(paidselected).toFixed(2);
                //var gstforthispayment = parseFloat(parseFloat(txtUserPayAmount)*(this.state.responseData.gst_percent/100)).toFixed(2);
                //console.log("balance", balance);
                //console.log("txtUserPayAmount", txtUserPayAmount);
                //console.log("paidselected", paidselected);
                //if (parseFloat(balance) > parseFloat(txtUserPayAmount) ) {
                //} else {
                //  txtUserPayAmount = parseFloat(txtUserPayAmount) - ( parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax)  )
                //}
                var rounding = 0;
                //Rounding flow
                if (paytableData[0].rounding) {
                  //var decimaltxtUserPayAmount = 1 - parseFloat(parseFloat(txtUserPayAmount).toFixed(2) % 1).toFixed(2);
                  //console.log(decimaltxtUserPayAmount);
                  txtUserPayAmount = parseFloat(txtUserPayAmount).toFixed(2);
                  var n = (txtUserPayAmount + "").split(".")[1].split("")[1];
                  var roundingBalance = 0;
                  console.log(n);
                  if (parseFloat(n) < 5 && parseFloat(n) != 0) {
                    roundingBalance = "0.0" + "" + (5 - parseFloat(n));
                  } else if (parseFloat(n) > 5) {
                    roundingBalance = "0.0" + "" + (10 - parseFloat(n));
                  }
                  console.log(roundingBalance);
                  roundingBalance = parseFloat(roundingBalance).toFixed(2);
                  txtUserPayAmount = parseFloat(
                    parseFloat(txtUserPayAmount) + parseFloat(roundingBalance)
                  ).toFixed(2);
                  console.log(roundingBalance);
                  console.log(txtUserPayAmount);
                  roundingBalanceAmount =
                    parseFloat(roundingBalance).toFixed(2);
                  //billableamount = parseFloat( parseFloat(billableamount) + parseFloat(roundingBalance) ).toFixed(2);
                  rounding = 1;
                }
                //Rounding flow

                var gstforthispayment = parseFloat(
                  (parseFloat(txtUserPayAmount) /
                    parseFloat(100 + this.state.responseData.gst_percent)) *
                    parseFloat(this.state.responseData.gst_percent)
                ).toFixed(2);
                console.log(gstforthispayment, "gstCheck");
                selectedCards.push({
                  pay_typeid: payTypeId,
                  pay_amt: parseFloat(txtUserPayAmount),
                  pay_gst: parseFloat(gstforthispayment),
                  credit_debit: false,
                  pay_premise: true,
                  prepaid: false,
                  pay_rem4: this.state.pay_rem4,
                  pay_is_rounding: rounding,
                });

                //console.log("paidselected", txtUserPayAmount);
                paidselected = parseFloat(
                  parseFloat(paidselected) + parseFloat(txtUserPayAmount)
                ).toFixed(2);
                balance = parseFloat(
                  parseFloat(balance) - parseFloat(txtUserPayAmount)
                ).toFixed(2);

                txtUserPayAmount = balance;
                if (parseFloat(txtUserPayAmount) < 0) {
                  txtUserPayAmount = 0;
                }
                console.log(txtUserPayAmount, "txtUserPayAmount2");

                //var totolGT2Tax =  parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax);
                //balance = parseFloat(balance - totolGT2Tax).toFixed(2);
                //billableamount = parseFloat(billableamount - gstforthispayment).toFixed(2);

                console.log("paidselected add", paidselected);
                this.setState({
                  txtUserPayAmount,
                  balance,
                  paidselected,
                  billableamount,
                  roundingBalanceAmount,
                });
                return;
              }

              this.handlePay(selPayTypeId, selPayTypeName);
            } else if (paytableData.length >= 1) {
              isOpenSubPayment = true;
              isSelectedPaymentType = "Multiple";
            }
            this.setState({
              isOpenSubPayment,
              isSelectedPaymentType,
              displayModelPaymentType,
            });
          }
        );
      });
  };

  handleDialog = async () => {
    let { isOpenSubPayment } = this.state;
    isOpenSubPayment = false;
    await this.setState({
      isOpenSubPayment,
    });
  };

  handlepaymentgateway = async () => {
    let { paymentgateway, txtUserPayAmount } = this.state;
    if (txtUserPayAmount !== "0") {
      paymentgateway = !paymentgateway;
    } else {
      Toast({
        type: "error",
        message: "Amount must be greater than 0",
      });
    }
    await this.setState({
      paymentgateway,
    });
    console.log(paymentgateway, txtUserPayAmount);
  };

  handleChangeCard = async ({ target: { value, name } }) => {
    let cardField = Object.assign({}, this.state.cardField);

    cardField[name] = value;

    await this.setState({
      cardField,
    });
  };

  handleMemberVoucher = async ({ target: { value, name } }) => {
    await this.setState({
      memberVoucherNumber: value,
    });
  };

  handleDatePick = async ({ target: { value, name } }) => {
    let { DateofPay } = this.state;
    DateofPay = value;
    await this.setState({
      DateofPay,
    });

    let DatePayment = {};
    DatePayment["DateofPayment"] = value;
    await this.props.updateForm("CartPaymentDate", DatePayment);
  };

  handleCallback = (childData) => {
    console.log(childData);
    this.setState({ paymentCompleted: childData });
  };

  successfullpayment = () => {
    return (
      <div className="success-msg">
        <svg
          width="4em"
          height="4em"
          viewBox="0 0 16 16"
          className="bi bi-check2 right"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"
          />
        </svg>
        <div className="title">Payment Successful</div>
      </div>
    );
  };

  /*
   Between the commented code has been changed as on 22/April/2022 by Saleem 
  */
  handleChangePointUserAmount(event) {
    this.setState({
      pointDataUserEnterAmount: event.target.value,
    });
  }

  addPoint = (RedeemableCurrency) => {
    //
    let {
      balance,
      txtUserPayAmount,
      isOpenSubPayment,
      selectedCards,
      pay_rem4,
      pointDataUserEnterAmount,
    } = this.state;

    if (Number(txtUserPayAmount) === 0) {
      Toast({
        type: "error",
        message: "Point is not allowed",
      });
      return;
    }
    if (pointDataUserEnterAmount == 0) {
      Toast({
        type: "warning",
        message: "Please enter the amount greater than zero",
      });
      return;
    }

    console.log(RedeemableCurrency);
    if (Number(pointDataUserEnterAmount) > Number(RedeemableCurrency)) {
      Toast({
        type: "error",
        message: "Entered Amount is greater than Redeemable Currency",
      });
      return false;
    } else if (Number(pointDataUserEnterAmount) > Number(txtUserPayAmount)) {
      Toast({
        type: "error",
        message: "Entered Amount should not greater than payable Amount",
      });
      return false;
    }
    const selectedPointAmount = parseFloat(pointDataUserEnterAmount);
    let pay_amt_setup = 0;
    if (selectedPointAmount <= parseFloat(txtUserPayAmount)) {
      pay_amt_setup = selectedPointAmount;
    } else {
      pay_amt_setup = txtUserPayAmount;
    }

    //const payTypeId = 25; //healspahq
    //const payTypeId = 23; //twoherbs
    //const payTypeId = 19; //healspa sensuous beauty21 appleskin jybeauty
    //const payTypeId = 7; //skinsoul
    //const payTypeId = 8; //glamour koiskin quantum
    //const payTypeId = 9; //beskin tnc ingenious
    //const payTypeId = 31; //cuttourtrain
    //const payTypeId = 37; //cuttour
    //const payTypeId = 35; //marma
    //const payTypeId = 12; //Embrace
    //const payTypeId = 10; //sincere
    //const payTypeId = 11; //Essentials
    //const payTypeId = 99; //no point for pixie citibella avante bestbeauty impression jybeauty
    //no point for my demo destress skinhugs magicion elva synthesis sumi ch skinsoul navis
    const payTypeId = this.getPayTableIdBasedOnPaygroupId();

    selectedCards.push({
      pay_typeid: payTypeId,
      pay_amt: parseFloat(pay_amt_setup),
      pay_premise: false,
      prepaid: false,
      credit_debit: false,
      points: true,
      cur_value: RedeemableCurrency,
      pay_rem4: this.state.pay_rem4, 
      pay_rem2: "",
      pay_gst: 0,
    });

    console.log("BeforeAdd-displayTableVoucher", this.state.displayTablePoint);
    //let setdisplayTablePoint = this.state.displayTablePoint;
    //setdisplayTablePoint.push(selectedPoint.id);
    //this.setState({ displayTablePoint: setdisplayTablePoint });
    //console.log("AfterAdd-displayTablePoint", this.state.displayTablePoint);
    //this.HidePointTableData();

    balance = parseFloat(balance - pay_amt_setup).toFixed(2);
    this.setState({ isOpenSubPayment: false });
    this.setBalanceToAllTextBoxes(balance);
  };

  /*
   Between the commented code has been changed as on 22/April/2022 by Saleem 
  */

  handleSignSaveClick = (imgData) => {
    let formData = new FormData();
    let { cartId } = this.props;
    formData.append("cart_id", cartId);
    formData.append("transaction_no", "");
    console.log("cart_id", cartId);
    formData.append("cust_sig", this.dataURLtoFile(imgData, `${cartId}.jpeg`));
    this.props
      .commonCreateApi(`tempcustsigninvoice/addsign/`, formData)
      .then((key) => {
        let { status, data } = key;
        console.log(key, "jhi");
        if (status == 201) {
          this.setState({
            signatureBtnDisable: false,
            signatureBtnHide: false,
          });
        }
        // if (status == 201) {
        //   history.push(`/admin/transactionhistory/print/bill/${cartId}`);
        // } else {
        //   alert("hi");
        // }
      });
  };
  dataURLtoFile = (dataurl, filename, mime) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  handlePay = (selPayTypeId, selPayTypeName) => {
    let {
      balance,
      selectedCards,
      txtUserPayAmount,
      paidselected,
      billableamount,
      prepaidTax,
      cnTax,
      voucherTax,
      roundingBalanceAmount,
      isOpenSubPayment,
      isSelectedPaymentType,
      displayModelPaymentType,
      paytableData,
    } = this.state;
    isSelectedPaymentType = selPayTypeName.trim().toUpperCase();
    displayModelPaymentType = selPayTypeName.trim().toUpperCase();

    let payTypeId = paytableData[0].value;

    isOpenSubPayment = false;
    this.setState({
      isOpenSubPayment,
      isSelectedPaymentType,
      displayModelPaymentType,
    });

    if (parseFloat(this.state.responseData.billable_amount) > 0) {
      if (parseFloat(txtUserPayAmount) == 0) {
        return;
      }
    }

    if (this.checkPayTypeIdAlreadyExists(payTypeId)) {
      let result = this.getPayTableNameBasedOnId(payTypeId) + " already exists";
      Toast({
        type: "error",
        message: result,
      });

      return;
    } else {
      console.log("addnewPayment", paytableData[0].rounding);
      //paidselected = parseFloat(paidselected).toFixed(2);
      //var gstforthispayment = parseFloat(parseFloat(txtUserPayAmount)*(this.state.responseData.gst_percent/100)).toFixed(2);
      //console.log("balance", balance);
      //console.log("txtUserPayAmount", txtUserPayAmount);
      //console.log("paidselected", paidselected);
      //if (parseFloat(balance) > parseFloat(txtUserPayAmount) ) {
      //} else {
      //  txtUserPayAmount = parseFloat(txtUserPayAmount) - ( parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax)  )
      //}
      var rounding = 0;
      //Rounding flow
      if (paytableData[0].rounding) {
        //var decimaltxtUserPayAmount = 1 - parseFloat(parseFloat(txtUserPayAmount).toFixed(2) % 1).toFixed(2);
        //console.log(decimaltxtUserPayAmount);
        txtUserPayAmount = parseFloat(txtUserPayAmount).toFixed(2);
        var n = (txtUserPayAmount + "").split(".")[1].split("")[1];
        var roundingBalance = 0;
        console.log(n);
        if (parseFloat(n) < 5 && parseFloat(n) != 0) {
          roundingBalance = "0.0" + "" + (5 - parseFloat(n));
        } else if (parseFloat(n) > 5) {
          roundingBalance = "0.0" + "" + (10 - parseFloat(n));
        }
        console.log(roundingBalance);
        roundingBalance = parseFloat(roundingBalance).toFixed(2);
        txtUserPayAmount = parseFloat(
          parseFloat(txtUserPayAmount) + parseFloat(roundingBalance)
        ).toFixed(2);
        console.log(roundingBalance);
        console.log(txtUserPayAmount);
        roundingBalanceAmount = parseFloat(roundingBalance).toFixed(2);
        //billableamount = parseFloat( parseFloat(billableamount) + parseFloat(roundingBalance) ).toFixed(2);
        rounding = 1;
      }
      //Rounding flow

      var gstforthispayment = parseFloat(
        (parseFloat(txtUserPayAmount) /
          parseFloat(100 + this.state.responseData.gst_percent)) *
          parseFloat(this.state.responseData.gst_percent)
      ).toFixed(2);

      selectedCards.push({
        pay_typeid: payTypeId,
        pay_amt: parseFloat(txtUserPayAmount),
        pay_gst: parseFloat(gstforthispayment),
        credit_debit: false,
        pay_premise: true,
        prepaid: false,
        pay_rem4: this.state.pay_rem4,
        pay_is_rounding: rounding,
      });
      //console.log("paidselected", txtUserPayAmount);
      paidselected = parseFloat(
        parseFloat(paidselected) + parseFloat(txtUserPayAmount)
      ).toFixed(2);
      balance = parseFloat(
        parseFloat(balance) - parseFloat(txtUserPayAmount)
      ).toFixed(2);

      txtUserPayAmount = balance;
      if (parseFloat(txtUserPayAmount) < 0) {
        txtUserPayAmount = 0;
      }
      console.log(txtUserPayAmount, "txtUserPayAmount2");

      //var totolGT2Tax =  parseFloat(prepaidTax) + parseFloat(cnTax) + parseFloat(voucherTax);
      //balance = parseFloat(balance - totolGT2Tax).toFixed(2);
      //billableamount = parseFloat(billableamount - gstforthispayment).toFixed(2);

      console.log("paidselected add", paidselected);
      this.setState({
        txtUserPayAmount,
        balance,
        paidselected,
        billableamount,
        roundingBalanceAmount,
      });
      return;
    }
  };

  handleInputChange = (inputId, event) => {
    const inputValue = event.target.value;

    this.setState((prevState) => ({
      stagedValues: {
        ...prevState.stagedValues,
        [inputId]: inputValue,
      },
    }));
  };

  //  alert(this.state.stagedValues[selectedPrepaid.id])

  handleValidateInput = async (data) => {
    debugger;
    var { txtUserPayAmount } = this.state;
    var userPayamount = parseFloat(txtUserPayAmount);
    let { id, redeem_amount } = data;
    let filterSelectedValues = this.state.selectedCards.find(
      (item) => item.pay_rem2 === data.id
    );

    if (filterSelectedValues) {
      userPayamount = userPayamount + parseFloat(filterSelectedValues.pay_amt);

      // alert(typeof userPayamount);
      // alert(userPayamount);
    }
    let findMinValue = Math.min(userPayamount, redeem_amount);
    if (parseFloat(this.state.stagedValues[id]) <= findMinValue) {
      let updateData = {
        ...data,
        redeem_amount: this.state.stagedValues[id],
        oldRedeem_amount: redeem_amount,
      };
      if (filterSelectedValues) {
        let updateUserPayAmount =
          userPayamount - parseFloat(this.state.stagedValues[id]);
        this.setState({ txtUserPayAmount: updateUserPayAmount }, () => {
          this.addPrepaid(updateData);
        });
      } else {
        this.addPrepaid(updateData);
      }
    } else {
      Toast({
        type: "error",
        message: "This value greater than amount",
      });
    }
  };

  handleLoginConfirmationDialog = () => {
    this.setState({
      isLoginConfirmation: !this.state.isLoginConfirmation,
    });
  };

  handleAuthentication = async (user, pass) => {
    let { selTypeId, selTypeName } = this.state;
    let Body = {
      username: user,
      password: pass,
      type: "Payment",
    };
    this.props
      .commonCreateApi(`userauthorizationpopup/`, Body)
      .then(async (key) => {
        let { status, data } = key;
        if (status == 200) {
          await this.setState((prevState) => ({
            isLoginConfirmation: !prevState.isLoginConfirmation,
          }));
          this.addNewPaymentData(selTypeId, selTypeName);
        }
      });
  };

  render() {
    let {
      responseData,
      balance,
      isTreatmentDoneButton,
      payGroupData,
      paytableData,
      isOpenSubPayment,
      isSelectedPaymentType,
      displayModelPaymentType,
      cardField,
      pay_rem4,
      DateofPay,
      MinimumDate,
      is_paymentdate,
      isMakePaymentLoading,
      paymentgateway,
      paymentCompleted,
      pointHeader,
      cust_id,
      cust_stripeid,
      billableamount,
      taxamt,
      roundingBalanceAmount,
      pointDataUserEnterAmount, //Saleem
      selectedCards,
      prepaidTotalUseAmt,
      isLoginConfirmation,
    } = this.state;
    let { t } = this.props;
    let { payTableDropDownValue } = this.state.formFields;
    console.log(payTableDropDownValue);
    let insideRadioButtonData;
    console.log(isSelectedPaymentType, "selectedpaymenttype");

    if (isSelectedPaymentType == "VOUCHER") {
      insideRadioButtonData = (
        <div>
          <table className="table table-bordered">
            <tr>
              <td>{t("Voucher No")}</td>
              <td>{t("Name")}</td>
              <td>{t("Value")}</td>
              <td>{t("Exp. Date")}</td>
            </tr>
            {this.state.voucherCustomerData.map((selectedVoucher, index) => (
              <tr
                key={index}
                style={{ cursor: "pointer" }}
                onClick={this.addVoucher.bind(this, selectedVoucher)}
              >
                <td>{selectedVoucher.voucher_no}</td>
                <td>{selectedVoucher.voucher_name}</td>
                <td>{selectedVoucher.value}</td>
                <td>{selectedVoucher.issued_expiry_date}</td>
              </tr>
            ))}
          </table>
        </div>
      );
    } else if (isSelectedPaymentType == "PREPAID") {
      insideRadioButtonData = (
        <div>
          <table className="table table-striped">
            <tr>
              <td>{t("Category")}</td>
              <td>{t("Amount")}</td>
              <td>{t("Remaining")}</td>
              <td>{t("Invoice No.")}</td>
              <td>{t("Exp. Date")}</td>
              <td>{t("Condition Type")}</td>
              <td>{t("Use Amount")}</td>
              {/* <td>{t("Enter Amount")}</td> */}
            </tr>
            {this.state.prepaidCustomerData.map((selectedPrepaid, index) => (
              <tr
                key={index}
                style={{ cursor: "pointer" }}
                onClick={this.addPrepaid.bind(this, selectedPrepaid)}
                // onClick={() => console.log(JSON.stringify(selectedPrepaid))}
              >
                <td>{selectedPrepaid.pp_desc}</td>
                <td className="text-left">{selectedPrepaid.pp_total}</td>
                <td className="text-left">{selectedPrepaid.remain}</td>
                <td>{selectedPrepaid.prepaid}</td>
                <td>{selectedPrepaid.exp_date}</td>
                <td>{selectedPrepaid.conditiontype1}</td>
                <td className="text-left">{selectedPrepaid.redeem_amount}</td>

                {/* <td className="d-flex align-items-center">
                  <div className="input-group">
                    <NormalInput
                      // value={pointDataUserEnterAmount}
                      name="pointDataUserEnterAmount"
                      onChange={(e) =>
                        this.handleInputChange(selectedPrepaid.id, e)
                      }
                      value={this.state.stagedValues[selectedPrepaid.id] || ""}
                      disabled={selectedPrepaid.redeem_amount === 0}
                    />
                  </div>

                  <NormalButton
                    label="Add"
                    mainbg={false}
                    onClick={() => this.handleValidateInput(selectedPrepaid)}
                    className="col-12 ml-2 btn-outline-success"
                    disabled={selectedPrepaid.redeem_amount === 0}
                  />
                </td> */}
              </tr>
            ))}
          </table>
        </div>
      );
    } else if (String(isSelectedPaymentType).toUpperCase() == "POINT") {
      console.log(this.state.pointHeader, "pointHeaderdata");
      /*
      insideRadioButtonData = (
        <div>
          <div className="d-flex flex-wrap py-1 mb-2">
            <div className="col-md-4 col-12">
              <label className="fw-600">{t("Customer Class")}</label>
              <div className="input-group">
                <label>{this.state.pointHeader.customer_class}</label>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <label className="fw-600">
                {t("Customer's Available Points")}
              </label>
              <div className="input-group">
                <label>{this.state.pointHeader.cust_point_value}</label>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <label className="fw-600">{t("Entered Points")}</label>
              <div className="input-group">
                <label>{this.state.pointHeader.enter_pointamt}</label>
              </div>
            </div>
          </div>
          <table className="table table-striped">
            <thead>
              <tr>
                <td>{t("Currency Value")}</td>
                <td>{t("Point Value")}</td>
                <td>{t("Division")}</td>
                <td>{t("Department")}</td>
                <td>{t("Brand")}</td>
              </tr>
            </thead>
            <tbody>
              {this.state.pointData.map((selectedPoint, index) => (
                <tr
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={this.addPoint.bind(this, selectedPoint)}
                >
                  {console.log(selectedPoint, "pointdatalog")}
                  <td>{selectedPoint.cur_value}</td>
                  <td>{selectedPoint.point_value}</td>
                  <td>{selectedPoint.item_divids_desc}</td>
                  <td>{selectedPoint.dept_ids_desc}</td>
                  <td>{selectedPoint.brand_ids_desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
      */
      {
        /* <td>{t("Use Amount")}</td> */
      }
      {
        /* <td>{selectedPoint.useamt}</td> */
      }
      insideRadioButtonData = (
        <div>
          <div className="d-flex flex-wrap py-1 mb-2">
            <div className="col-md-2 col-12">
              <label className="fw-600">{t("Customer Class")}</label>
              <div className="input-group">
                <label>{this.state.pointHeader.customer_class}</label>
              </div>
            </div>
            <div className="col-md-2 col-12">
              <label className="fw-600">
                {t("Customer's Available Points")}
              </label>
              <div className="input-group">
                <label>{this.state.pointHeader.cust_point_value}</label>
              </div>
            </div>
            <div className="col-md-2 col-12">
              <label className="fw-600">{t("Total Currency Available")}</label>
              <div className="input-group">
                <label>{this.state.pointHeader.RedeemableCurrency}</label>
              </div>
            </div>
            <div className="col-md-2 col-12">
              <label className="fw-600">{t("Entered Amount to use")}</label>
              <div className="input-group">
                <NormalInput
                  value={pointDataUserEnterAmount}
                  name="pointDataUserEnterAmount"
                  onChange={this.handleChangePointUserAmount.bind(this)}
                />
                {this.validator.message(
                  "pointDataUserEnterAmount",
                  this.state.pointDataUserEnterAmount,
                  "required|numeric|min:0,num"
                )}
                {this.validator.message(
                  "pointDataUserEnterAmountBalance",
                  this.state.pointDataUserEnterAmount,
                  "required|numeric|max:" + this.state.balance + ",num"
                )}
              </div>
            </div>
            <div className="col-md-2 col-12 pt-60 pr-10">
              <div className="input-group">
                <NormalButton
                  label="Proceed"
                  mainbg={false}
                  onClick={this.addPoint.bind(
                    this,
                    this.state.pointHeader.RedeemableCurrency
                  )}
                  className="col-12 mt-4 ml-2 btn-outline-success"
                />
              </div>
            </div>
          </div>
          <p className="pt-10 pb-10">Calculation Logic</p>
          <br />
          <table className="table table-striped">
            <thead>
              <tr>
                {/* <td>{t("Use Amount")}</td> */}
                <td>{t("Division")}</td>
                <td>{t("Department")}</td>
                <td>{t("Brand")}</td>
                <td>{t("Point Value")}</td>
                <td>{t("Currency Value")}</td>
                <td>{t("Use Amount")}</td>
              </tr>
            </thead>
            <tbody>
              {this.state.pointData.map((selectedPoint, index) => (
                <tr key={index} style={{ cursor: "pointer" }}>
                  {console.log(selectedPoint, "pointdatalog")}
                  {/* <td>{selectedPoint.useamt}</td> */}
                  <td>{selectedPoint.item_divids_desc}</td>
                  <td>{selectedPoint.dept_ids_desc}</td>
                  <td>{selectedPoint.brand_ids_desc}</td>
                  <td>{selectedPoint.point_value}</td>
                  <td>{selectedPoint.cur_value}</td>
                  <td>{selectedPoint.useamt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    } else if (isSelectedPaymentType.toUpperCase() == "CREDIT") {
      insideRadioButtonData = (
        <div>
          {console.log(
            "this.state.creditNoteCustomerData",
            JSON.stringify(this.state.creditNoteCustomerData)
          )}
          <table className="table table-striped">
            <tr>
              <td>{t("Credit")} #</td>
              <td>{t("Date")}</td>
              <td>{t("Amount")}</td>
              <td>{t("Balance")}</td>
              <td>{t("Status")}</td>
            </tr>
            {this.state.creditNoteCustomerData.map((creditNote, index) => (
              <tr
                key={index}
                style={{ cursor: "pointer" }}
                onClick={this.addCreditNote.bind(this, creditNote)}
              >
                <td>{creditNote.credit_code}</td>
                <td>{creditNote.sa_date}</td>
                <td>{creditNote.amount}</td>
                <td>{creditNote.balance}</td>
                <td>{creditNote.status}</td>
              </tr>
            ))}
          </table>
        </div>
      );
    } else if (isSelectedPaymentType.toUpperCase() == "MEMBER VOUCHER") {
      insideRadioButtonData = (
        <div className="col-12">
          <div className="d-flex flex-wrap justify-content-center">
            <div className="col-md-6 col-sm-8 col-lg-4 col-12 py-2">
              <div className="input-group">
                {t("Voucher No.")}
                <NormalInput
                  value={this.state.memberVoucherNumber}
                  name="memberVoucherNumber"
                  onChange={this.handleMemberVoucher}
                />
              </div>
              <div>
                {this.validator.message(
                  "memberVoucherNumber",
                  this.state.memberVoucherNumber,
                  "required"
                )}
              </div>
            </div>
            <div className="col-md-6 col-sm-4 col-12 py-2">
              <div className="input-group my-3">
                <NormalButton
                  mainbg={false}
                  className="col-12 btn-outline-success"
                  label="CONFIRM"
                  onClick={() => this.validateMemberVoucher()}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (isSelectedPaymentType == "CARD") {
      insideRadioButtonData = (
        <div>
          <div className="d-flex flex-wrap justify-content-center">
            <div className="col-11">
              <p>{t("Select Card")}</p>
              <div className="d-flex flex-wrap">
                {/* <NormalSelect
                  placeholder="Search type..."
                  options={paytableData}
                  value={cardField.pay_typeid}
                  name="pay_typeid"
                  onChange={this.handleCreditChange}
                /> */}

                {paytableData.length > 0 &&
                  paytableData.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`${
                          item.value == cardField.pay_typeid ? "activeCard" : ""
                        } border border-info p-2 m-2`}
                        onClick={() =>
                          this.handleCreditChange(item.value, "pay_typeid")
                        }
                      >
                        <img
                          src={item.payimage}
                          alt=""
                          height={"64px"}
                          width={"64px"}
                          style={{ objectFit: "contain" }}
                        />
                        <br></br>
                        <span>{item.label}</span>
                      </div>
                    );
                  })}
              </div>
              {this.validator.message(
                "cardFieldType",
                cardField.pay_typeid,
                "required"
              )}
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-around">
            <div className="col-md-5 col-12">
              <div className="input-group">
                {t("Card No.")}
                <NormalInput
                  value={cardField.pay_rem1}
                  name="pay_rem1"
                  onChange={this.handleChangeCard}
                />
              </div>
            </div>

            <div className="col-md-5 col-12">
              <div className="input-group">
                {t("Name")}
                <NormalInput
                  value={cardField.pay_rem2}
                  name="pay_rem2"
                  onChange={this.handleChangeCard}
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-around">
            <div className="col-md-5 col-12">
              <div className="input-group">
                {t("Exp Month")} / {t("Year")}
                <NormalInput
                  placeholder="mm/YYYY"
                  value={cardField.pay_rem3}
                  name="pay_rem3"
                  onChange={this.handleChangeCard}
                />
              </div>
            </div>

            <div className="col-md-5 col-12">
              <div className="input-group">
                {t("Approval Code")}
                <NormalInput
                  value={cardField.App_code}
                  name="App_code"
                  onChange={this.handleChangeCard}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end my-2">
            <div className="col-md-2 col-12">
              <div className="input-group">
                <NormalButton
                  mainbg={false}
                  className="col-12 btn-outline-success"
                  label="CONFIRM"
                  onClick={() => this.addCreditCard()}
                />
              </div>
            </div>
            {/* <div className="col-2">
              <div className="input-group">
                <NormalButton
                  mainbg={true}
                  className="col-12 mt-4 ml-2"
                  label="CANCEL"
                  onClick={() => this.setState({ isOpenSubPayment: false })}
                />
              </div>
            </div> */}
          </div>
        </div>
      );
    } else if (isSelectedPaymentType == "ONLINE PAYMENT") {
      insideRadioButtonData = (
        <div>
          <div className="d-flex flex-wrap justify-content-around">
            <div className="col-md-5 col-12">
              <div className="input-group">
                {t("SCAN & PAY")}
                <div className="col-12">
                  {paytableData.length > 0 &&
                    paytableData
                      .filter((data) => data?.label == "ONLINE PAYMENT")
                      .map((item, index) => {
                        return (
                          <>
                            {" "}
                            <div className="col-md-6 col-12 py-2" key={index}>
                              <img
                                src={item.qr_code}
                                alt=""
                                height={"200px"}
                                width={"200px"}
                                style={{ objectFit: "contain" }}
                              />
                              <br></br>
                            </div>
                            <div className="d-flex justify-content-center my-2">
                              <div className="col-md-2 col-12">
                                <div className="input-group">
                                  <NormalButton
                                    mainbg={false}
                                    className="col-12 btn-outline-success"
                                    label="CONTINUE"
                                    onClick={() =>
                                      this.handlePay("", item?.label)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (isSelectedPaymentType == "Multiple") {
      insideRadioButtonData = (
        <div>
          <div className="row">
            <div className="col-12">
              <div className="input-group p-3">
                <Label className="col-12 fs-15 pb-3 pl-0">
                  {t("Choose Option")} common
                </Label>
                {/* <NormalSelect
                  placeholder="Search type..."
                  options={paytableData}
                  value={payTableDropDownValue}
                  name="payTableDropDownValue"
                  onChange={this.handleChange}
                /> */}

                {paytableData.length > 0 &&
                  paytableData.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`${
                          (selectedCards?.filter(
                            (key) => key.pay_typeid == item.value
                          )).length > 0
                            ? "activeCard"
                            : ""
                        } border border-info p-2 m-2`}
                        onClick={() =>
                          this.handleChange(item.value, "pay_typeid")
                        }
                      >
                        <img
                          src={item.payimage}
                          alt=""
                          height={"64px"}
                          width={"64px"}
                          style={{ objectFit: "contain" }}
                        />
                        <br></br>
                        <span>{item.label}</span>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      insideRadioButtonData = <div></div>;
    }
    let payGroupDataContent = [];
    payGroupData.forEach((item, i) => {
      payGroupDataContent.push(
        <div
          className={`col-md-3 col-4 payment-item cursor-pointer ${
            Number(this.state.txtUserPayAmount) <= 0 && item.label != "CASH" && item.label != "OLD BILL" && item.label != "VOUCHER"
              ? "paymentDisabledCard"
              : ""
          }`}
          style={{ width: "50px", padding: "15px" }}
          key={i}
          onClick={() => {
            if (item?.isLogin) {
              this.setState({
                selTypeId: item.value,
                selTypeName: item.label,
                isLoginConfirmation: true,
              });
            } else {
              this.addNewPaymentData(item.value, item.label);
            }
          }}
        >
          <center>
            <img
              src={helpers.getMediaUrl() + "media/" + item.picturelocation}
              label={item.label}
              style={{ textAlign: "center" }}
              width="40"
              height="40"
            />
          </center>
          <center>
            <p style={{ width: "100px", textAlign: "center" }}>{item.label}</p>
          </center>
        </div>
      );
    });

    let { cartId, cartData, tokenDetails } = this.props;
    console.log(cartId, tokenDetails, this.props.cartData);
    this.checkTypeOfCartItemContainsDeposit(cartData);
    console.log("data", this.state.selectedCards);

    let userAddedPayTableData = (
      <table className="table table-bordered">
        <tbody>
          {" "}
          {console.log("selectedCards", JSON.stringify(selectedCards))}
          {this.state.selectedCards.map((selectedCards, index) => (
            <tr key={index}>
              <td className="fs-18">
                {this.getPayTableNameBasedOnId(selectedCards.pay_typeid)}
              </td>
              <td className="fs-18" style={{ textAlign: "right" }}>
                {selectedCards.pay_amt.toFixed(2)}
              </td>
              <td className="fs-18" style={{ textAlign: "right" }}>
                {selectedCards.pay_gst
                  ? selectedCards.pay_gst.toFixed(2)
                  : selectedCards.pay_gst}
              </td>
              <td>
                <div
                  className="col-4 p-0 fs-20 cursor-pointer"
                  onClick={this.removeCards(selectedCards)}
                >
                  <span className="icon-delete"></span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
    return (
      <React.Fragment>
        <div className="d-flex flex-wrap">
          <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2  mb-2">
            <label className="text-left text-black common-label-text ">
              {t("Enter Amount")}
            </label>

            <div className="input-group mb-2">
              <NormalInput
                value={this.state.txtUserPayAmount}
                onChange={this.handleChangeTextBox.bind(this)}
              />
              {this.validator.message(
                "Amount",
                this.state.txtUserPayAmount,
                "required|numeric|min:0,num"
              )}
              {this.validator.message(
                "Amount",
                this.state.txtUserPayAmount,
                "required|numeric|max:" + this.state.txtUserPayAmount + ",num"
              )}
            </div>
          </div>
          <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3  mb-2">
            <Label>{t("Remark")}</Label>
            <div className="input-group mb-2">
              <NormalInput
                value={pay_rem4}
                name="pay_rem4"
                onChange={this.handleChangeRemarkBox.bind(this)}
              />
            </div>
          </div>
          {is_paymentdate ? (
            <div className="col-md-2 col-12 mb-2">
              <>
                <Label>{t("Date")}</Label>
                <div className="input-group mb-2">
                  <NormalDate
                    value={new Date(DateofPay)}
                    name="DateofPay"
                    type="date"
                    onChange={this.handleDatePick}
                    minDate={new Date(MinimumDate)}
                    maxDate={new Date()}
                    showDisabledMonthNavigation
                  />
                </div>
              </>
            </div>
          ) : null}

          <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5">
            <div className="d-flex justify-content-end">
              {isTreatmentDoneButton ? (
                <div className="make-payment mt-3 mr-2 text-center">
                  <NormalButton
                    mainbg={true}
                    className="col-12 fs-15"
                    label="TREATMENT DONE"
                    onClick={() => this.handleTreatmentDone()}
                  />
                </div>
              ) : null}
              <div className="make-payment mt-3 text-center">
                {isMakePaymentLoading ? (
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">{t("Loading...")}</span>
                    </div>
                  </div>
                ) : this.state.isMakePaymentButtonClicked == "true" ? (
                  <NormalButton
                    submitBtn={true}
                    className="col-12"
                    label="Make payment"
                    disabled={true}
                  />
                ) : (
                  <NormalButton
                    id={`makePayment`}
                    submitBtn={true}
                    className="col-12"
                    label="Make payment"
                    onClick={() => this.handleSubmit()}
                    disabled={
                      this.state.selectedCards.length <= 0 || balance > 0
                    }
                  />
                )}
              </div>
              <div className="make-payment mt-3 ml-2 text-center">
                <NormalButton
                  submitBtn={true}
                  className="col-12"
                  label="print preview"
                  onClick={() => this.handlePrintPreview()}
                  disabled={this.state.selectedCards.length <= 0 || balance > 0}
                />
              </div>
              {/* <div className="make-payment mt-3 ml-2 text-center">
                <NormalButton
                  submitBtn={true}
                  className="col-12"
                  label=""
                  onClick={() => this.runConnect()}
                  disabled={this.state.selectedCards.length <= 0 || balance > 0}
                />
              </div> */}
            </div>
          </div>
        </div>

        <div className="d-flex ">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h5>{t("Select Payment Method")}</h5>
          </div>

          {this.props.tokenDetails.paymentgateway == true ? (
            <div className="col-3">
              <NormalButton
                mainbg={true}
                className="col-12"
                label="payment Gateway"
                onClick={this.handlepaymentgateway}
              />
            </div>
          ) : null}
        </div>

        <div className="row paymentGroup">
          <div className="col-md-6">
            <div className="d-flex flex-wrap">{payGroupDataContent}</div>
          </div>
          <div className="col-md-6 make-payment-section">
            <p className="h6">{t("List of Selections")}</p>
            <div className="row">
              <div className="col-md-12 mt-1 mb-1">
                <div className="d-flex payment">
                  <div className="col-md-7 p-0">
                    <div className="d-flex flex-wrap fs-14">
                      <div className="col-6">{t("Subtotal")}</div>
                      <div className="col-6">$ {responseData.subtotal}</div>
                      <div className="col-6">{t("Discount ($)")}</div>
                      <div className="col-6">$ {responseData.discount}</div>
                      <div className="col-6">{t("Transac amount")}</div>
                      <div className="col-6">$ {responseData.trans_amt}</div>
                      <div className="col-6">{t("Rounding")}</div>
                      <div className="col-6">$ {roundingBalanceAmount}</div>
                      <div className="col-6">{t("Deposit")}</div>
                      <div className="col-6">
                        ${" "}
                        {parseFloat(
                          parseFloat(responseData.deposit_amt) +
                            parseFloat(roundingBalanceAmount)
                        ).toFixed(2)}
                      </div>
                      <div className="col-6">{responseData.tax_lable}</div>
                      <div className="col-6">$ {taxamt}</div>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="d-flex flex-wrap">
                      <div className="col-12 fs-22 text-center">
                        {t("Billing Amount")}
                      </div>
                      <div className="col-12 fs-22 fw-700 text-center text-orenge">
                        ${" "}
                        {parseFloat(
                          parseFloat(billableamount) +
                            parseFloat(roundingBalanceAmount)
                        ).toFixed(2)}
                      </div>
                      <div className="col-12 f-600 text-center mt-2">
                        {t("Balance Amount")}:{" "}
                        {parseFloat(
                          parseFloat(balance) +
                            parseFloat(roundingBalanceAmount)
                        ).toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-2 payment-list">
              <div className="fs-12">{userAddedPayTableData}</div>
            </div>
            <div className="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-6 text-right mt-1 mx-auto ">
              {this.state.cust_sign ? (
                <>
                  <img
                    className={`sigImage`}
                    alt=""
                    width={200}
                    height={150}
                    style={{ objectFit: "scale-down" }}
                    src={this.state.cust_sign}
                  />
                  <p>Customer Signature</p>
                </>
              ) : (
                <SignPanel
                  handleSignSaveClick={(imgData) =>
                    this.handleSignSaveClick(imgData)
                  }
                  handleToClearSigPad={() => this.handleClearSign()}
                  //handleToHideBtns={this.state.signatureBtnHide}
                />
              )}
            </div>
            {console.log(this.state.cust_sign, "custSign")}
            {/* <div className="d-flex justify-content-around">
              {isTreatmentDoneButton ? (
                <div className="make-payment mt-3 text-center">
                  <NormalButton
                    mainbg={true}
                    className="col-12 fs-15 "
                    label="TREATMENT DONE"
                    onClick={() => this.handleTreatmentDone()}
                  />
                </div>
              ) : null}
              <div className="make-payment mt-3 text-center">
                {isMakePaymentLoading ? (
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">{t("Loading...")}</span>
                    </div>
                  </div>
                ) : this.state.isMakePaymentButtonClicked == "true" ? (
                  <NormalButton
                    submitBtn={true}
                    className="col-12"
                    label="Make payment"
                    disabled={true}
                  />
                ) : (
                  <NormalButton
                    submitBtn={true}
                    className="col-12"
                    label="Make payment"
                    onClick={() => this.handleSubmit()}
                    disabled={
                      this.state.selectedCards.length <= 0 || balance > 0
                    }
                  />
                )}
              </div>
            </div> */}
          </div>
        </div>

        <NormalModal
          className={"payment-modal"}
          style={{ minWidth: "70%" }}
          modal={isOpenSubPayment}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          {console.log("prepaidTotalUseAmt", prepaidTotalUseAmt)}
          <center>
            <p className="fs-18 f-600">
              {displayModelPaymentType}
              {isSelectedPaymentType == "PREPAID"
                ? " (Total Use Amount " + prepaidTotalUseAmt + " )"
                : ""}
            </p>
          </center>
          <br />
          {insideRadioButtonData}
        </NormalModal>

        <NormalModal
          className={"payment-modal"}
          style={{ minWidth: "30%" }}
          modal={paymentgateway}
          handleModal={this.handlepaymentgateway}
        >
          <img
            onClick={this.handlepaymentgateway}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />

          {/*paymentCompleted ? (
            this.successfullpayment()
          ) : (
            <React.Fragment>
              <div className="col-md-12 order-md-1">
                <Elements stripe={stripePromise}>
                  <Paymentcheckout
                    amount={balance}
                    parentCallback={this.handleCallback}
                    cartId={cartId}
                    cust_id={cust_id}
                    cust_stripeid={cust_stripeid}
                    //   token={this.props.tokenDetails}
                  />
                </Elements>
              </div>
            </React.Fragment>
          )*/}
        </NormalModal>
        <NormalModal
              className={"d-flex justify-content-center"}
              style={{ minWidth: "20%" }}
              modal={isLoginConfirmation}
              handleModal={() => {}}
            >
              <img
                onClick={this.handleLoginConfirmationDialog}
                className="close cursor-pointer"
                src={closeIcon}
                alt=""
              />
              <CredentialConfirmation
                handleLoginSubmit={(user, pass) =>
                  this.handleAuthentication(user, pass)
                }
              />
            </NormalModal>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  appointmentDetail: state.appointment.appointmentDetail,
  selected_cstomer: state.common.selected_cstomer,
  tokenDetails: state.authStore.tokenDetails,
  CartPaymentDate: state.appointment.CartPaymentDate,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPayment,
      getCommonApi,
      createPayment,
      updateForm,
      commonCreateApi,
      commonDeleteApi,
      transactionSettingListAct,
    },
    dispatch
  );
};

export const Payment = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(MakePaymentClass)
);
